webpackJsonp([1],{

/***/ "+LT/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "/2qG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "/3u5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"clave-unica-error"}},[_c('b-row',{staticClass:"m-0 text-azul h6 col-12 col-lg-9 mx-auto"},[_c('b-col',{staticClass:"mt-3 mt-lg-2 mb-1 mb-lg-2 text-center",attrs:{"cols":"12"}},[_c('span',{staticClass:"gilmer text-uppercase text-azul-medio h4 font-weight-light"},[_vm._v("Clave única")])]),_vm._v(" "),_c('b-col',{staticClass:"text-gris text-center text-lg-center px-0 px-lg-4 border-bottom pb-2 border-azul-claro2 border-2 gilmer mx-auto mb-3",attrs:{"cols":"12"}},[_vm._v("El tiempo para ingresar su clave única expiró, por favor intente\n      nuevamente")])],1),_vm._v(" "),_c('b-col',{staticClass:"mb-2 mt-3 mt-lg-5 px-0 px-lg-3 text-center mb-5",attrs:{"cols":"12"}},[_c('router-link',{staticClass:"btn btn-lg btn-azul-oscuro2 gilmer text-left pr-3 mt-2 text-uppercase px-4 font-weight-bold",attrs:{"data-testid":"button-volver","to":{ name: 'Inicio' }}},[_vm._v("Volver\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1iRa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"source-sans border-bottom border-4 border-azul-medio imagen-fondo-header"},[_c('b-container',[_c('b-row',[_c('b-col',{staticClass:"p-0 m-0 order-1"},[_c('div',{staticClass:"p-0 logo ml-auto mr-2 mr-lg-0 mb-2"})]),_vm._v(" "),_c('b-col',{staticClass:"text-right"},[_c('img',{staticClass:"img-fluid d-block mt-1 mb-2 mt-lg-2",attrs:{"src":"https://cdnsae.mineduc.cl/logos/Logo6.png","width":"220","alt":""}})])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1uJz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__ = __webpack_require__("C/JF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_free_solid_svg_icons__ = __webpack_require__("fhbW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__("1e6/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_1__fortawesome_free_solid_svg_icons__["g" /* faEye */]);
__WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_1__fortawesome_free_solid_svg_icons__["h" /* faEyeSlash */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["etiqueta", "negrita", "grande", "dataTestid", "maxlength", "estado", "mensajeError"],
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__["a" /* FontAwesomeIcon */]
  },
  data: function data() {
    return {
      tipoInput: "password",
      icono: "eye",
      mostrar: true
    };
  },

  methods: {
    mostrarcontrasena: function mostrarcontrasena() {
      if (this.mostrar) {
        this.tipoInput = "text";
        this.icono = "eye-slash";
        this.mostrar = false;
      } else {
        this.tipoInput = "password";
        this.icono = "eye";
        this.mostrar = true;
      }
    },
    handler: function handler(evento) {
      this.$emit("input", evento.target.value);
    },
    change: function change(evento) {
      this.$emit("change", evento);
    },
    blur: function blur(evento) {
      this.$emit("blur", evento);
    },
    keyup: function keyup(evento) {
      this.$emit("keyup", evento);
    }
  }
});

/***/ }),

/***/ "2Gi9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"mt-auto bg-azul-claro3 text-azul source-sans d-print-none",attrs:{"align-v":"end"}},[_c('b-container',[_c('b-row',[_c('b-col',{staticClass:"small pt-3 text-center text-md-left",attrs:{"cols":"12","md":"7","lg":"8","order":"1","order-md":"0"}},[_c('div',[_vm._v("Ministerio de Educación de Chile")]),_vm._v(" "),_c('a',{staticClass:"d-block font-weight-bold text-azul",attrs:{"href":"https://www.gob.cl","target":"_blank"}},[_vm._v("Gobierno de Chile")]),_vm._v(" "),_c('div',[_vm._v("Av. Libertador Bernardo O'Higgins 1371.")]),_vm._v(" "),_c('div',{staticClass:"text-azul-claro"},[_vm._v("Versión "+_vm._s(_vm.version))])]),_vm._v(" "),_c('b-container',{staticClass:"col-12 col-md-5 col-lg-4 order-0 order-md-1 pt-2 text-right"},[_c('b-col',{staticClass:"pt-3 text-center"},[_vm._v("\n          Consultas al siguiente teléfono\n        ")]),_vm._v(" "),_c('b-col',{staticClass:"text-center"},[_c('FontAwesomeIcon',{staticClass:"fa-2x mt-2 d-none d-lg-inline-block",attrs:{"icon":"phone"}}),_vm._v(" "),_c('span',{staticClass:"h2 d-none d-lg-inline-block ml-2 font-weight-bold"},[_vm._v("600 600 2626")]),_vm._v(" "),_c('FontAwesomeIcon',{staticClass:"d-inline-block d-lg-none h5",attrs:{"icon":"phone"}}),_vm._v(" "),_c('a',{staticStyle:{"color":"azul"},attrs:{"href":"tel:6006002626"}},[_c('span',{staticClass:"h4 d-inline-block d-lg-none ml-1 font-weight-bold"},[_vm._v("600 600 2626")])])],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"mt-4 mt-md-2 p-0 text-center text-md-left",attrs:{"cols":"12"}},[_c('img',{attrs:{"src":"https://cdnsae.mineduc.cl/logos/Logo1.png","width":"160","height":"15","alt":""}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2ROQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bfb9188_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClaveUnicaError_vue__ = __webpack_require__("/3u5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bfb9188_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClaveUnicaError_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2gpL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2iYk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pantalla-2da7892.png";

/***/ }),

/***/ "38nF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecuperarContrasena_vue__ = __webpack_require__("DptF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58004879_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecuperarContrasena_vue__ = __webpack_require__("L5Hh");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecuperarContrasena_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58004879_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecuperarContrasena_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3HKp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4yu6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('img',{staticClass:"img-fluid d-block mt-1 mb-2 mt-lg-2",attrs:{"src":"https://cdnsae.mineduc.cl/logos/Logo10.png","alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "58OK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mensaje_vue__ = __webpack_require__("SZVz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0356a01b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mensaje_vue__ = __webpack_require__("fYu+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mensaje_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0356a01b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mensaje_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5Yow":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__ = __webpack_require__("C/JF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_free_solid_svg_icons__ = __webpack_require__("fhbW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__("1e6/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_1__fortawesome_free_solid_svg_icons__["f" /* faPhone */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__["a" /* FontAwesomeIcon */]
  },
  data: function data() {
    return {
      version: "2.4.89"
    };
  }
});

/***/ }),

/***/ "6XKy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformacionResultadosFinales_vue__ = __webpack_require__("D2Z/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27840fd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformacionResultadosFinales_vue__ = __webpack_require__("p4Vt");
function injectStyle (ssrContext) {
  __webpack_require__("QdUX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformacionResultadosFinales_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27840fd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformacionResultadosFinales_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "76OY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8VWt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8zks":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_login_InformacionAceptaCondiciones__ = __webpack_require__("jd3S");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    InformacionAceptaCondiciones: __WEBPACK_IMPORTED_MODULE_0__components_login_InformacionAceptaCondiciones__["a" /* default */]
  },
  name: "InformacionPostulacionComplementaria",
  data: function data() {
    return {
      ayuda: "https://www.ayudamineduc.cl/tema/54946#55265",
      fechaComplementario: ""
    };
  },
  created: function created() {
    var obtenerValorLocalStorage = function obtenerValorLocalStorage(key) {
      var valorPorDefecto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "----";

      var valor = localStorage.getItem(key);
      return valor ? valor : valorPorDefecto;
    };

    this.fechaComplementario = obtenerValorLocalStorage("fechaPeriodoComplementario");
  }
});

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9OqG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformacionListaDeEspera_vue__ = __webpack_require__("Eqrg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee1b9c44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformacionListaDeEspera_vue__ = __webpack_require__("NRXF");
function injectStyle (ssrContext) {
  __webpack_require__("EcGo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformacionListaDeEspera_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee1b9c44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformacionListaDeEspera_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9WJ8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:_vm.reference,class:_vm.computedClass,attrs:{"data-testid":_vm.dataTest,"id":_vm.id,"type":_vm.type,"disabled":!_vm.loaded || _vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.click.apply(null, arguments)}}},[_vm._t("default"),_vm._v(" "),_c('div',{attrs:{"id":_vm.recaptchaId,"data-size":"invisible"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9i+Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Errores__ = __webpack_require__("LQJy");



var _this = this;



var loginClaveUnica = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(credenciales) {
    var login;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a;

          case 2:
            login = _context.sent;

            location.href = "https://apisae.mineduc.cl/sae-api-registro-persona/" + "login/claveunica";
            return _context.abrupt("return", "");

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function loginClaveUnica(_x) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  loginClaveUnica: loginClaveUnica
});

/***/ }),

/***/ "A/Qe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "InformacionResultados",
  data: function data() {
    return {
      ayuda: "https://ayudamineduc.cl/ficha/resultados-periodo-principal-de-postulacion-y-de-lista-de-espera",
      fechaListaEspera: ""
    };
  },
  created: function created() {
    var obtenerValorLocalStorage = function obtenerValorLocalStorage(key) {
      var valorPorDefecto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "----";

      var valor = localStorage.getItem(key);
      return valor ? valor : valorPorDefecto;
    };

    this.fechaListaEspera = obtenerValorLocalStorage("fechaListaEspera");
  }
});

/***/ }),

/***/ "BCjB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md order-1 order-md-0"},[_c('div',{staticClass:"text-azul-medio text-uppercase gilmer h4 text-center mt-5 mt-md-3 font-weight-light"},[_vm._v("\n    Acerca del proceso\n  ")]),_vm._v(" "),_c('div',{staticClass:"bg-azul-claro py-4 px-4 h6 text-center rounded"},[_vm._v("\n    El\n    "),_c('strong',[_vm._v("Periodo Complementario de Postulación")]),_vm._v(" está disponible en\n    este portal desde el\n    "),_c('strong',[_vm._v(_vm._s(_vm.fechaComplementario))]),_vm._v(" "),_c('img',{staticClass:"img-fluid my-4",attrs:{"src":"https://cdnsaemineduc.s3.us-east-1.amazonaws.com/img/calendario-periodo-complementario.svg","width":"280","alt":""}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"bg-azul-claro py-3 px-4 h6 text-center rounded mt-5 mt-lg-3"},[_c('a',{staticClass:"gilmer h5 font-weight-light",attrs:{"href":_vm.ayuda,"data-testid":"enlace-ayuda-mineduc","target":"_blank"}},[_c('strong',{staticClass:"d-inline-block"},[_vm._v("¿Dudas con tu postulación?")]),_vm._v(" "),_c('span',{staticClass:"d-inline-block mt-2 text-uppercase font-weight-bold subrayado h6"},[_vm._v("Consulta Ayuda Mineduc")])])]),_vm._v(" "),_c('InformacionAceptaCondiciones')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-azul-medio rounded py-4 text-white gilmer mx-0 mx-lg-3"},[_vm._v("\n      Accede con el mismo\n      "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("USUARIO")]),_vm._v(" y\n      "),_c('strong',[_vm._v("CONTRASEÑA")]),_vm._v(" "),_c('br'),_vm._v("del proceso de postulación\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BsyW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CI4P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ca6f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"cols":"12","md":"","lg":"6","sm":"12","order":"1","order-md":"0"}},[_c('div',{staticClass:"text-azul-medio text-uppercase gilmer h5 text-center mt-md-4 font-weight-light"}),_vm._v(" "),_c('div',{staticClass:"h6 text-center rounded text-white px-0 bg-azul-medio w-100 py-3"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"12"}},[_c('div',{staticClass:"gilmer text-uppercase h5 mx-3 mx-lg-6 mt-4"},[_c('b',[_vm._v("¿QUÉ ES EL SISTEMA DE ADMISIÓN ESCOLAR?")])]),_vm._v(" "),_c('div',{staticClass:"form-group mx-4 mt-4 text-justify m-1 h5"},[_c('span',{staticClass:"d-block mb-2"},[_vm._v("\n            Es el mecanismo oficial para postular a establecimientos públicos\n            y particulares subvencionados en Chile.\n          ")]),_vm._v(" "),_c('span',{staticClass:"d-block mb-2 resalta text-justify"},[_vm._v("\n            Podrás postular entre el "+_vm._s(_vm.inicioPostulacion)+" y el\n            "+_vm._s(_vm.finPostulacion)+".\n          ")]),_vm._v(" "),_c('span',{staticClass:"d-block mb-2"},[_vm._v("\n            Revisa con atención las fechas de postulación, resultados y\n            matrícula de Admisión Escolar "+_vm._s(_vm.anioAdmision)+".\n          ")])])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","lg":"12"}},[_c('div',{staticClass:"form-group mx-4 mt-2 text-justify m-1 h5"},[_c('p',{staticClass:"d-block mb-2"},[_vm._v("\n            Aquí podrás conocer todos los colegios disponibles para postular:\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group mx-4 mx-lg-5 mt-3 text-center"},[_c('router-link',{staticClass:"btn-lg btn-azul-oscuro2 text-uppercase gilmer font-weight-bold w-100",attrs:{"data-testid":"button-ver-establecimientos","to":{ name: 'Vitrina' },"type":"submit"}},[_vm._v("VER ESTABLECIMIENTOS")])],1)]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","lg":"12"}},[_c('div',{staticClass:"form-group mx-4 mt-1 text-justify m-1 h5"},[_c('p',{staticClass:"d-block mb-2"},[_vm._v("\n            Utiliza los filtros por comuna, nivel, jornada u otros criterios\n            para encontrar las mejores opciones para ti.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group mx-4 mt-2 text-justify m-1 h5"},[_c('p',{staticClass:"d-block mb-2"},[_vm._v("\n            Tómate el tiempo necesario para revisar las características de\n            cada establecimiento antes de postular.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group mx-4 mt-2 text-center m-1 h5"},[_c('p',{staticClass:"d-block mb-2"},[_vm._v("\n            Para más información, visita:\n            "),_c('a',{staticClass:"no-hover-color",attrs:{"href":"https://www.sistemadeadmisionescolar.cl","target":"_blank"}},[_vm._v("www.sistemadeadmisionescolar.cl")])])])])],1)],1),_vm._v(" "),_c('InformacionAceptaCondiciones')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D2Z/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "InformacionResultadosFinales",
  data: function data() {
    return {
      ayuda: "https://www.ayudamineduc.cl/tema/54946#55265",
      fechaResultadosFinales: ""
    };
  },
  created: function created() {
    var obtenerValorLocalStorage = function obtenerValorLocalStorage(key) {
      var valorPorDefecto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "----";

      var valor = localStorage.getItem(key);
      return valor ? valor : valorPorDefecto;
    };

    this.fechaResultadosFinales = obtenerValorLocalStorage("fechaResultadosFinales");
  }
});

/***/ }),

/***/ "DptF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generales_Volver__ = __webpack_require__("hP5U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generales_TituloRecuperarContrasena__ = __webpack_require__("ksXs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_manejoErrores__ = __webpack_require__("xdtW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generales_inputs_InputPasswordWrapper__ = __webpack_require__("GDUu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_js_validador__ = __webpack_require__("J7t/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_ApiLogin__ = __webpack_require__("jxoT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_generales_modales_Mensaje__ = __webpack_require__("58OK");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__assets_js_manejoErrores__["a" /* manejoErrores */]],
  components: {
    Volver: __WEBPACK_IMPORTED_MODULE_2__components_generales_Volver__["a" /* default */],
    Titulo: __WEBPACK_IMPORTED_MODULE_3__components_generales_TituloRecuperarContrasena__["a" /* default */],
    InputPasswordWrapper: __WEBPACK_IMPORTED_MODULE_5__components_generales_inputs_InputPasswordWrapper__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_8__components_generales_modales_Mensaje__["a" /* default */]
  },
  data: function data() {
    return {
      recuperar: {
        id: this.$route.params.id,
        medio: this.$route.params.medio == "correo" ? 0 : this.$route.params.medio == "telefono" ? 1 : 2,
        numeroValidacion: "",
        clave: ""
      },
      medioSeleccionado: [{ text: "correo electrónico" }, { text: "teléfono móvil" }],
      codigoValidacion: "",
      confirmarClave: ""
    };
  },

  methods: {
    enviarFormualrio: function enviarFormualrio() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var cambiarclave;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_7__services_ApiLogin__["a" /* default */].cambiarClave(_this.recuperar, _this);

              case 2:
                cambiarclave = _context.sent;

                if (cambiarclave) {
                  _this.$refs.modalExitoso.showModal();
                }
                _this.$emit("cargado");
                return _context.abrupt("return", true);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    validarFomulario: function validarFomulario() {
      this.$emit("cargar");
      var validado = true;
      this.modificado = ["codigo", "password", "password2"];
      var valido = [this.validarCodigoValid(), this.validarPassword("password", this.recuperar.clave), this.validarPassword("password2", this.confirmarClave)];
      if (valido.includes(false)) {
        validado = false;
        this.$emit("cargado");
      }
      return validado;
    },
    validarCodigoValid: function validarCodigoValid() {
      var valor = this.codigoValidacion;
      var campo = "codigo";
      var valido = true;
      this.limpiarError(campo);
      if (valor.length < 1) {
        this.guardarError(campo, "Debe ingresar el código de seguridad enviado al medio de contacto seleccionado.");
        valido = false;
      }
      if (valido) {
        this.recuperar.numeroValidacion = parseInt(valor);
      }
      return valido;
    },
    validarPassword: function validarPassword(campo, valor) {
      var valido = true;
      var mensaje = "Contraseña no válida: ";
      var errores = [];
      this.limpiarError(campo);

      if (valor.length < 1) {
        errores.push("La contraseña es un campo obligatorio");
      } else if (!__WEBPACK_IMPORTED_MODULE_6__assets_js_validador__["a" /* default */].validarExpresion("password", valor)) {
        errores.push("La contraseña debe tener mínimo 8 caracteres y debe contener al menos una letra mayúscula, una letra minúscula, un número y un símbolo. Ejemplo contraseña: Abcdef1#");
      }
      if (errores.length > 0) {
        this.guardarError(campo, errores[0]);
        valido = false;
      }

      if (valido) {
        this.limpiarError("password");
        this.limpiarError("password2");
        if (!(this.recuperar.clave === this.confirmarClave)) {
          this.guardarError("password", "");
          this.guardarError("password2", "Las contraseñas ingresadas no coinciden");
          valido = false;
        }
      }
      return valido;
    }
  }
});

/***/ }),

/***/ "EKLV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var meses = [{ id: "01", mes: "Enero", dias: 31 }, { id: "02", mes: "Febrero", dias: 29 }, { id: "03", mes: "Marzo", dias: 31 }, { id: "04", mes: "Abril", dias: 30 }, { id: "05", mes: "Mayo", dias: 31 }, { id: "06", mes: "Junio", dias: 30 }, { id: "07", mes: "Julio", dias: 31 }, { id: "08", mes: "Agosto", dias: 31 }, { id: "09", mes: "Septiembre", dias: 30 }, { id: "10", mes: "Octubre", dias: 31 }, { id: "11", mes: "Noviembre", dias: 30 }, { id: "12", mes: "Diciembre", dias: 31 }];

/* harmony default export */ __webpack_exports__["a"] = ({
  meses: meses
});

/***/ }),

/***/ "EUrt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("5Yow");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b6da50c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("2Gi9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b6da50c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EcGo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Eqrg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "InformacionListaDeEspera",
  data: function data() {
    return {
      ayuda: "https://ayudamineduc.cl/ficha/resultados-periodo-principal-de-postulacion-y-de-lista-de-espera",
      fechaListaEspera: ""
    };
  },
  created: function created() {
    var obtenerValorLocalStorage = function obtenerValorLocalStorage(key) {
      var valorPorDefecto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "----";

      var valor = localStorage.getItem(key);
      return valor ? valor : valorPorDefecto;
    };

    this.fechaListaEspera = obtenerValorLocalStorage("fechaListaEspera");
  }
});

/***/ }),

/***/ "Fk90":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputWrapperSerie_vue__ = __webpack_require__("JgNh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb2508ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputWrapperSerie_vue__ = __webpack_require__("psb7");
function injectStyle (ssrContext) {
  __webpack_require__("YkU1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cb2508ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputWrapperSerie_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb2508ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputWrapperSerie_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G0Pf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InicioRegistro_vue__ = __webpack_require__("/2qG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d2eac3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InicioRegistro_vue__ = __webpack_require__("j82G");
function injectStyle (ssrContext) {
  __webpack_require__("f8rH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InicioRegistro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d2eac3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InicioRegistro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GDUu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputPasswordWrapper_vue__ = __webpack_require__("1uJz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66850985_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputPasswordWrapper_vue__ = __webpack_require__("fwmn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputPasswordWrapper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66850985_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputPasswordWrapper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GaqC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformacionResultados_vue__ = __webpack_require__("A/Qe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d48356e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformacionResultados_vue__ = __webpack_require__("MtFV");
function injectStyle (ssrContext) {
  __webpack_require__("8VWt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformacionResultados_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d48356e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformacionResultados_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gdnz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_ApiLogin__ = __webpack_require__("jxoT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_ApiDirectorio__ = __webpack_require__("KN05");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_ApiClaveUnica__ = __webpack_require__("9i+Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_js_manejoErrores__ = __webpack_require__("xdtW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_js_validador__ = __webpack_require__("J7t/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_js_formatoRut__ = __webpack_require__("c4fo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_generales_recaptcha_InvisibleRecaptcha__ = __webpack_require__("VdD7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fortawesome_free_solid_svg_icons__ = __webpack_require__("fhbW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_login_InformacionPostulacion__ = __webpack_require__("ezNm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_login_InformacionPostulacionRegistroAnticipado__ = __webpack_require__("J4rf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_login_InformacionResultados__ = __webpack_require__("GaqC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_login_InformacionListaDeEspera__ = __webpack_require__("9OqG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_login_InformacionPostulacionComplementaria__ = __webpack_require__("NcpV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_login_InformacionResultadosFinales__ = __webpack_require__("6XKy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_login_InformacionRegistro__ = __webpack_require__("gV00");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Inicio_InicioRegistro__ = __webpack_require__("G0Pf");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__assets_js_manejoErrores__["a" /* manejoErrores */]],
  components: {
    InvisibleRecaptcha: __WEBPACK_IMPORTED_MODULE_8__components_generales_recaptcha_InvisibleRecaptcha__["a" /* default */],
    InformacionPostulacion: __WEBPACK_IMPORTED_MODULE_10__components_login_InformacionPostulacion__["a" /* default */],
    InformacionPostulacionRegistroAnticipado: __WEBPACK_IMPORTED_MODULE_11__components_login_InformacionPostulacionRegistroAnticipado__["a" /* default */],
    InformacionResultados: __WEBPACK_IMPORTED_MODULE_12__components_login_InformacionResultados__["a" /* default */],
    InformacionListaDeEspera: __WEBPACK_IMPORTED_MODULE_13__components_login_InformacionListaDeEspera__["a" /* default */],
    InformacionPostulacionComplementaria: __WEBPACK_IMPORTED_MODULE_14__components_login_InformacionPostulacionComplementaria__["a" /* default */],
    InformacionResultadosFinales: __WEBPACK_IMPORTED_MODULE_15__components_login_InformacionResultadosFinales__["a" /* default */],
    InformacionRegistro: __WEBPACK_IMPORTED_MODULE_16__components_login_InformacionRegistro__["a" /* default */],
    InicioRegistro: __WEBPACK_IMPORTED_MODULE_17__components_Inicio_InicioRegistro__["a" /* default */]
  },
  data: function data() {
    return {
      usuario: {
        run: "",
        clave: ""
      },
      config: {
        headers: {},
        params: {}
      },
      siteKey: "6LfE9rYqAAAAACUgAep0DVg4Nzpk4DQmnq1VlEy-",
      rut: "",
      errorRut: false,
      errorPass: false,
      tiempoToken: 15 * 60 * 1000,
      ayuda: "https://www.ayudamineduc.cl/ficha/postulacion-al-sistema-de-admision-escolar",
      etapaProceso: null,
      captchaHabilitado: localStorage.getItem("recatpchaHabilitado") || "true",
      claveunica: false,
      anioAdmision: localStorage.getItem("anioAdmision") || "2026",
      etapaCargada: false,
      intervalId: null,
      previousValue: localStorage.getItem("etapaProceso")
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.intervalId = setInterval(function () {
      var currentValue = localStorage.getItem("etapaProceso");
      if (currentValue !== _this.previousValue) {
        window.location.reload();
      }
    }, 1000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
  },
  created: function created() {
    this.obtieneParametros();
  },

  computed: {
    titulo: function titulo() {
      switch (this.etapaProceso) {
        case "POSTULACION":
          "Realiza tu postulación";
          break;
        case "COMPLEMENTARIO":
          return "PERIODO COMPLEMENTARIO";
          break;
        default:
          break;
      }
    }
  },
  methods: {
    obtieneParametros: function obtieneParametros() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var tokenBearer, etapaValor;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                tokenBearer = "eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJhZG1pc2lvbi1lc2NvbGFyIiwiaWF0IjoxNzQ4ODgxNDE0LCJleHAiOjE3ODA0MTc0MTQsImlkUG9zdHVsYWNpb24iOiI2ODNkYmZhODhiYmZmMzAwMDE5YWY1ZmYiLCJpc0FkbWluIjpmYWxzZX0.3AztlB-nsLnr-Pe2-mzyo3gzRaEAowUZq2-VeumajHE";
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3__services_ApiDirectorio__["a" /* default */].obtenerInformacion(_this2, tokenBearer);

              case 4:
                etapaValor = _context.sent;

                if (etapaValor.resultadoEtapa) {
                  _this2.etapaCargada = true;
                  localStorage.setItem("etapaProceso", etapaValor.resultadoEtapa);
                  localStorage.setItem("anioSiguiente", etapaValor.parametroAnioSiguiente.valor);
                  localStorage.setItem("anioAnterior", etapaValor.parametroAnioAnterior.valor);
                  localStorage.setItem("anioIndicadorCatDesempenioBasica", etapaValor.parametroAnioIndicadorCatDesempenioBasica.valor);
                  localStorage.setItem("anioIndicadorCatDesempenioMedia", etapaValor.parametroAnioIndicadorCatDesempenioMedia.valor);
                  localStorage.setItem("anioIndicadorCatSimceBasica", etapaValor.parametroAnioIndicadorCatSimceBasica.valor);
                  localStorage.setItem("anioIndicadorCatSimceMedia", etapaValor.parametroAnioIndicadorCatSimceMedia.valor);
                  localStorage.setItem("anioIndicadorCatDesarrolloBasica", etapaValor.parametroAnioIndicadorCatDesarrolloBasica.valor);
                  localStorage.setItem("anioIndicadorCatDesarrolloMedia", etapaValor.parametroAnioIndicadorCatDesarrolloMedia.valor);
                  localStorage.setItem("mostrarVacantes", etapaValor.parametroMostrarVacantes.valor);
                  localStorage.setItem("mostrarProcedimientosEspeciales", etapaValor.parametroMostrarProcedimientosEspeciales.valor);
                  localStorage.setItem("modoEnvioCorreo", etapaValor.parametroModoEnvioCorreo.valor);
                  localStorage.setItem("anioPostulacion", etapaValor.parametroAnioPostulacion.valor);
                  localStorage.setItem("anioAdmision", etapaValor.parametroAnioAdmision.valor);
                  localStorage.setItem("inicioPostulacion", etapaValor.parametroInicioPostulacion.valor);
                  localStorage.setItem("finPostulacion", etapaValor.parametroFinPostulacion.valor);
                  localStorage.setItem("fechaListaEspera", etapaValor.parametroFechaListaEspera.valor);
                  localStorage.setItem("fechaPeriodoComplementario", etapaValor.parametroFechaPeriodoComplementario.valor);
                  localStorage.setItem("fechaResultadosFinales", etapaValor.parametroFechaResultadosFinales.valor);
                  localStorage.setItem("modoRecuperarPassword", etapaValor.parametroModoRecuperarPassword.valor);
                  localStorage.setItem("recaptchaHabilitado", etapaValor.parametroRecaptchaHabilitado.valor);
                  _this2.etapaProceso = etapaValor.resultadoEtapa;
                } else {
                  console.error("No se obtuvo la etapa correctamente.");
                }
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

                console.error("Error al cargar la etapa:", _context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 8]]);
      }))();
    },


    //ELIMINAR ANTES DE PRODUCCION
    pruebaAutomatizada: function pruebaAutomatizada() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var formValido;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                formValido = _this3.validarCredenciales();

                if (!formValido) {
                  _context2.next = 6;
                  break;
                }

                _this3.config.headers = {
                  "g-recaptcha-response": "recaptchaToken"
                };
                _this3.config.params = {
                  tipoCaptcha: "INVISIBLE"
                };
                _context2.next = 6;
                return _this3.loguear();

              case 6:
                _this3.emitCargado();

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },

    //ELIMINAR ANTES DE PRODUCCION
    captcha: function captcha(recaptchaToken) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!recaptchaToken) {
                  _context3.next = 5;
                  break;
                }

                _this4.config.headers = {
                  "g-recaptcha-response": recaptchaToken
                };
                _this4.config.params = {
                  tipoCaptcha: "INVISIBLE"
                };
                _context3.next = 5;
                return _this4.loguear();

              case 5:
                _this4.emitCargado();

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    emitCargar: function emitCargar() {
      this.$emit("cargar");
    },
    emitCargado: function emitCargado() {
      this.$emit("cargado");
    },
    validarCredenciales: function validarCredenciales() {
      this.emitCargar();
      this.modificado = ["rut", "pass"];
      var valido = [this.validarRut(), this.validarPassword()];
      var validado = true;
      if (valido.includes(false)) {
        validado = false;
        this.emitCargado();
      }

      return validado;
    },
    formatoRut: function formatoRut() {
      this.rut = __WEBPACK_IMPORTED_MODULE_7__assets_js_formatoRut__["a" /* default */].formateaRut(this.rut);
    },
    validarRut: function validarRut() {
      var valido = true;
      var valor = this.rut;
      var campo = "rut";
      this.limpiarError(campo);
      this.errorRut = false;
      if (valor.length < 1) {
        this.guardarError(campo, "Ingrese su RUN.");
        valido = false;
      } else if (!__WEBPACK_IMPORTED_MODULE_6__assets_js_validador__["a" /* default */].validarExpresion("rut", valor) || !__WEBPACK_IMPORTED_MODULE_7__assets_js_formatoRut__["a" /* default */].digitoVerificador(valor)) {
        this.guardarError(campo, "El Run no es válido");
        valido = false;
      }
      if (valido) {
        this.usuario.run = parseInt(valor.slice(0, -1).split(".").join("").replace("-", ""));
      } else {
        this.errorRut = true;
      }
      return valido;
    },
    validarPassword: function validarPassword() {
      var valido = true;
      var errores = [];
      var campo = "pass";
      var valor = this.usuario.clave;
      this.limpiarError(campo);
      this.errorPass = false;
      if (valor.length < 1) {
        errores.push("Ingrese su contraseña");
      } else if (valor.length < 8) {
        errores.push("Contraseña no válida");
      }
      if (errores.length > 0) {
        this.guardarError(campo, errores[0]);
        this.errorPass = true;
        valido = false;
      }
      return valido;
    },

    //TODO: Revisar que el jwt se mantenga en el sessionstorage, porque cuando se cambia de dominio se pierde
    loguear: function loguear() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var loguear;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.$emit("cargar");
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2__services_ApiLogin__["a" /* default */].loguearUsuario(_this5.usuario, _this5, _this5.config);

              case 3:
                loguear = _context4.sent;

                if (loguear) {
                  _this5.$ss.set("jwt", loguear.token, _this5.tiempoToken);
                  _this5.$ss.set("esClaveSegura", loguear.esClaveSegura, _this5.tiempoToken);

                  if (_this5.$ss.get("jwt", "") === "") {
                    _this5.$ss.set("jwt", loguear, _this5.tiempoToken);
                  }
                  if (_this5.etapaProceso === "POSTULACION" || _this5.etapaProceso === "COMPLEMENTARIO" || _this5.etapaProceso === "REGISTRO_ANTICIPADO") {
                    _this5.$router.push({ name: "Postulacion" });
                  } else if (_this5.etapaProceso === "NORMAL" || _this5.etapaProceso === "LISTA_DE_ESPERA" || _this5.etapaProceso === "RESULTADO_FINAL") {
                    _this5.$router.push({ name: "Resultados" });
                  }
                } else {
                  _this5.usuario.run = "";
                  _this5.rut = "";
                  _this5.usuario.clave = "";
                  _this5.$emit("cargado");
                }

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    cargarClaveUnica: function cargarClaveUnica() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var loguear;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.$emit("cargar clave unica");
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__services_ApiClaveUnica__["a" /* default */].loginClaveUnica();

              case 3:
                loguear = _context5.sent;

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    }
  }
});

/***/ }),

/***/ "GrQD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_manejoErrores__ = __webpack_require__("xdtW");


//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__assets_js_manejoErrores__["a" /* manejoErrores */]],
  components: {},
  data: function data() {
    return {
      usuario: {
        run: "",
        clave: ""
      },
      config: {
        headers: {},
        params: {}
      },
      siteKey: "6LfE9rYqAAAAACUgAep0DVg4Nzpk4DQmnq1VlEy-",
      rut: "",
      errorRut: false,
      errorPass: false,
      tiempoToken: 15 * 60 * 1000,
      ayuda: "https://www.ayudamineduc.cl/ficha/postulacion-al-sistema-de-admision-escolar",
      etapaProceso: null
    };
  },
  created: function created() {
    this.fetchData();
  },

  mounted: function mounted() {
    this.guardarSession();
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var tokenBearer, etapaValor;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                tokenBearer = "eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJhZG1pc2lvbi1lc2NvbGFyIiwiaWF0IjoxNzQ4ODgxNDE0LCJleHAiOjE3ODA0MTc0MTQsImlkUG9zdHVsYWNpb24iOiI2ODNkYmZhODhiYmZmMzAwMDE5YWY1ZmYiLCJpc0FkbWluIjpmYWxzZX0.3AztlB-nsLnr-Pe2-mzyo3gzRaEAowUZq2-VeumajHE";
                _context.next = 4;
                return ApiDirectorio.obtenerInformacion(_this, tokenBearer);

              case 4:
                etapaValor = _context.sent;

                if (etapaValor) {
                  _this.etapaProceso = etapaValor;
                } else {
                  console.error("No se obtuvo la etapa correctamente.");
                }
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

                console.error("Error al cargar la etapa:", _context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    },
    guardarSession: function guardarSession() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$emit("cargar");
                _this2.$ss.set("jwt", _this2.$route.query.token, _this2.tiempoToken);
                _this2.$ss.set("claveunica", true, _this2.tiempoToken);
                _this2.$ss.set("esClaveSegura", true, _this2.tiempoToken);
                setTimeout(function () {
                  return _this2.isHidden = false;
                }, 5000);

                if (_this2.etapaProceso === "POSTULACION" || _this2.etapaProceso === "COMPLEMENTARIO" || _this2.etapaProceso === "REGISTRO_ANTICIPADO") {
                  _this2.$router.push({ name: "Postulacion" });
                } else if (_this2.etapaProceso === "NORMAL" || _this2.etapaProceso === "LISTA_DE_ESPERA" || _this2.etapaProceso === "RESULTADO_FINAL") {
                  _this2.$router.push({ name: "Resultados" });
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),

/***/ "HK7E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h6 text-center rounded text-white px-0 bg-condiciones w-100 pb-2 pt-2"},[_c('h5',{staticClass:"gilmer"},[_c('strong',[_vm._v("¡ATENCIÓN!")])]),_vm._v(" "),_c('div',{staticClass:"col p-2 text-justify"},[_c('span',{staticClass:"inicial h5"},[_vm._v("Si tu estudiante es asignado a un nuevo establecimiento,\n      "),_c('strong',[_vm._v("perderá automáticamente su cupo en el colegio actual para el próximo\n        año, independientemente de si aceptas o rechazas la asignación durante\n        la etapa de resultados.\n      ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I0nj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inicio_vue__ = __webpack_require__("Gdnz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_608af1c7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inicio_vue__ = __webpack_require__("SCsV");
function injectStyle (ssrContext) {
  __webpack_require__("pKYy")
  __webpack_require__("bAMU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-608af1c7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inicio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_608af1c7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inicio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I23l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"cols":"12","md":"","lg":"6","sm":"12","order":"1","order-md":"0"}},[_c('div',{staticClass:"text-azul-medio text-uppercase gilmer h5 text-center mt-5 mt-md-3 font-weight-light"},[_vm._v("\n    Postulación "+_vm._s(_vm.anioPostulacion)+" - Año académico "+_vm._s(_vm.anioAdmision)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"bg-azul-claro2 py-4 px-4 h6 text-center rounded"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"6"}},[_c('img',{staticClass:"img-fluid mb-3",attrs:{"src":__webpack_require__("2iYk"),"alt":""}})]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","lg":"6"}},[_c('p',{staticClass:"inicial p-3 h5"},[_vm._v("\n          Revisa aquí todos los establecimientos a los que puedes postular\n        ")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-azul-outline text-uppercase font-weight-bold h5",attrs:{"data-testid":"button-ver-establecimientos","to":{ name: 'Vitrina' }}},[_vm._v("Ver establecimientos")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-justify p-2 h5"},[_vm._v("\n    Regístrate al sistema desde el 19 de julio y postula desde el\n    "),_c('strong',[_vm._v("10 de agosto")]),_vm._v(". Recuerda que tienes hasta el 7 de\n    septiembre para postular.\n  ")]),_vm._v(" "),_c('div',{staticClass:"bg-azul-claro py-4 px-4 h6 text-center rounded mt-5 mt-lg-4"},[_c('a',{staticClass:"gilmer h5 font-weight-light",attrs:{"href":_vm.ayuda,"data-testid":"enlace-ayuda-mineduc","target":"_blank"}},[_c('strong',{staticClass:"col-12 d-inline-block text-azul-medio"},[_vm._v("¿Dudas para postular?")]),_vm._v(" "),_c('span',{staticClass:"d-inline-block btn btn-azul-outline mt-2 text-uppercase font-weight-bold"},[_vm._v("Consulta Ayuda Mineduc")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "INPx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TituloRegistro_vue__ = __webpack_require__("xzdP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48762220_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TituloRegistro_vue__ = __webpack_require__("o4SK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TituloRegistro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48762220_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TituloRegistro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IocX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"clave-unica-usuario-no-registrado"}},[_c('b-row',{staticClass:"m-0 text-azul h6 col-12 col-lg-9 mx-auto"},[_c('b-col',{staticClass:"mt-3 mt-lg-2 mb-1 mb-lg-2 text-center",attrs:{"cols":"12"}},[_c('span',{staticClass:"gilmer text-uppercase text-azul-medio h4 font-weight-light"},[_vm._v("Usuario no registrado")])]),_vm._v(" "),_c('b-col',{staticClass:"text-gris text-center text-lg-center px-0 px-lg-4 border-bottom pb-2 border-azul-claro2 border-2 gilmer mx-auto mb-3",attrs:{"cols":"12"}},[_vm._v("Debe registrarse como usuario para poder ingresar al sistema")])],1),_vm._v(" "),_c('b-col',{staticClass:"mb-2 mt-3 mt-lg-5 px-0 px-lg-3 text-center mb-5",attrs:{"cols":"12"}},[_c('router-link',{staticClass:"btn btn-lg btn-azul-oscuro2 gilmer text-left pr-3 mt-2 text-uppercase px-4 font-weight-bold",attrs:{"data-testid":"button-volver","to":{ name: 'Registro' }}},[_vm._v("REGISTRARME\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "J4rf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformacionPostulacionRegistroAnticipado_vue__ = __webpack_require__("JozH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbf2b62c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformacionPostulacionRegistroAnticipado_vue__ = __webpack_require__("LfIW");
function injectStyle (ssrContext) {
  __webpack_require__("J7LG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cbf2b62c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformacionPostulacionRegistroAnticipado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbf2b62c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformacionPostulacionRegistroAnticipado_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J7LG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J7t/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var validarExpresion = function validarExpresion(tipo, expresion) {
  var valido = true;
  switch (tipo) {
    case "rut":
      valido = /^(\d{0,3}\.\d{3}\.\d{3}-(\d|K|k))|(\d{6,9}-?(\d|k|K))|(\d{3}\.\d{3}-(\d|K|k))$/.test(expresion);
      break;

    case "correo":
      valido = /^([A-Z|a-z|0-9](\.|_){0,1})+[A-Z|a-z|0-9]\@([A-Z|a-z|0-9])+((\.){0,1}[A-Z|a-z|0-9]){2}\.[A-Z|a-z]{2,3}$/.test(expresion);
      break;

    case "telefono":
      valido = /^((\d{9,})|(\d{8})|(\d{1}\s\d{3}\s\d{2}\s?\d{2})|(\d{1}\s\d{7}))$/.test(expresion);
      break;

    case "telefono-longitud":
      valido = /^(\d{9,})$/.test(expresion);
      break;

    case "serie":
      valido = /^([A-Za-z0-9]{3})\.([0-9]{3})\.([0-9]{3})$/.test(expresion);
      break;

    case "password":
      valido = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W]).{8,16}$/.test(expresion);
      break;

    case "fecha":
      if (/^(\d{2})(\/\d{2}\/|-\d{2}-)(\d{4})$/.test(expresion)) {
        var t = expresion.split(expresion.charAt(2));
        var d = +t[0],
            m = +t[1] - 1,
            y = +t[2];
        var date = new Date(y, m, d);
        if (date.getFullYear() === y && date.getMonth() === m) {
          valido = true;
        } else {
          valido = false;
        }
      } else {
        valido = false;
      }
      break;

    default:
      break;
  }
  return valido;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  validarExpresion: validarExpresion
});

/***/ }),

/***/ "JgNh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__ = __webpack_require__("C/JF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_free_solid_svg_icons__ = __webpack_require__("fhbW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__("1e6/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_1__fortawesome_free_solid_svg_icons__["l" /* faInfo */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["negrita", "state", "mensajeError", "grande", "value"],
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__["a" /* FontAwesomeIcon */]
  },
  methods: {
    handler: function handler(evento) {
      this.$emit("input", evento.target.value);
    },
    change: function change(evento) {
      this.$emit("change", evento);
    },
    blur: function blur(evento) {
      this.$emit("blur", evento);
    },
    keyup: function keyup(evento) {
      this.$emit("keyup", evento);
    }
  }
});

/***/ }),

/***/ "JozH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "InformacionPostulacion",
  data: function data() {
    return {
      ayuda: "https://www.ayudamineduc.cl/ficha/postulacion-al-sistema-de-admision-escolar",
      anioPostulacion: "",
      anioAdmision: "",
      inicioPostulacion: "",
      finPostulacion: ""
    };
  },
  created: function created() {
    var obtenerValorLocalStorage = function obtenerValorLocalStorage(key) {
      var valorPorDefecto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "----";

      var valor = localStorage.getItem(key);
      return valor ? valor : valorPorDefecto;
    };

    this.anioPostulacion = obtenerValorLocalStorage("anioPostulacion");
    this.anioAdmision = obtenerValorLocalStorage("anioAdmision");
    this.inicioPostulacion = obtenerValorLocalStorage("inicioPostulacion");
    this.finPostulacion = obtenerValorLocalStorage("finPostulacion");
  },

  computed: {
    noTieneMiercoles: function noTieneMiercoles() {
      return !(this.inicioPostulacion.includes("Miércoles") || this.inicioPostulacion.includes("Miercoles") || this.finPostulacion.includes("Miércoles") || this.finPostulacion.includes("Miercoles"));
    }
  }
});

/***/ }),

/***/ "Jqxn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"m-0 text-azul h6 col-12 col-lg-9 mx-auto"},[_c('b-col',{staticClass:"mt-3 mt-lg-2 mb-1 mb-lg-2 text-center",attrs:{"cols":"12"}},[_c('span',{staticClass:"h3 gilmer text-azul mt-2 font-weight-bold text-lg-center"},[_vm._v("Recuperar Contraseña")])]),_vm._v(" "),_c('b-col',{staticClass:"subtitulo-cursiva text-azul text-center text-lg-center px-4 border-bottom pb-2 border-azul-claro2 border-2 gilmer mx-auto col-lg-10 col-12",attrs:{"cols":"12"}},[_vm._v(_vm._s(_vm.subtitulo))]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "K+cs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"registro",attrs:{"id":"Registro"}},[_c('Volver',{attrs:{"redireccion":"Inicio"}}),_vm._v(" "),_c('Titulo',{attrs:{"titulo":"Registro apoderado(a) para postular en el Sistema de Admisión Escolar","subtitulo":"Si no tienes RUN chileno, no debes registrarte acá. Obtén tu Identificador Provisorio de Apoderado (IPA) <a href=\"https://ayudamineduc.cl/tramites-en-linea\" target=\"_blank\" style=\"text-decoration: underline;\">aquí</a> <br>\n    Completa todos los campos del formulario. <br> Es fundamental que ingreses un correo electrónico y número de teléfono\n    válidos y actualizados, ya que serán los medios oficiales para informarte sobre el proceso de postulación\n    y los resultados de asignación.","tamanioTitulo":"h3"}}),_vm._v(" "),_c('b-form',{on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();}}},[_c('b-row',{staticClass:"col-12 col-lg-10 px-2 px-lg-5 text-azul mx-auto"},[_c('b-col',{staticClass:"gilmer h5 font-weight-bold mt-4 text-center text-lg-left",attrs:{"cols":"12"}},[_vm._v("Datos del Apoderado(a)")]),_vm._v(" "),_c('b-col',{staticClass:"mt-3 borde-grupo",attrs:{"cols":"12","md":"3"}},[_c('InputTextWrapper',{attrs:{"data-testing":"form-run","etiqueta":"RUN","placeholder":"21.123.456-1","estado":this.tieneError('run'),"mensajeError":this.mensajeError('run'),"maxlength":"12","prepend":"false","textInputgroup":""},on:{"~keyup":function($event){return _vm.modificado.push('run')},"change":_vm.validarRut,"keyup":_vm.formatoRut},model:{value:(_vm.rut),callback:function ($$v) {_vm.rut=$$v},expression:"rut"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mt-3",attrs:{"cols":"12","md":"5"}},[_c('label',{staticClass:"mb-1"},[_vm._v("Fecha de nacimiento")]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('b-col',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dia),expression:"dia"}],staticClass:"form-control redondo-derecho",attrs:{"data-testid":"form-fecha-dia","id":"dia"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dia=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.limpiarError('fecha');
                _vm.validarFechaCompleta();}]}},[_c('option',{attrs:{"value":"null","disabled":""}},[_vm._v("Día")]),_vm._v(" "),_vm._l((31),function(dia){return _c('option',{key:("dia-" + dia),domProps:{"value":dia}},[_vm._v(_vm._s(dia))])})],2)]),_vm._v(" "),_c('b-col',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.mes),expression:"mes"}],staticClass:"form-control redondo-derecho",attrs:{"data-testid":"form-fecha-mes","id":"mes"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.mes=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.limpiarError('fecha');
                _vm.validarFechaCompleta();}]}},[_c('option',{attrs:{"value":"null","disabled":""}},[_vm._v("Mes")]),_vm._v(" "),_vm._l((_vm.meses),function(mes){return _c('option',{key:("mes-" + (mes.id)),domProps:{"value":mes.id}},[_vm._v(_vm._s(mes.mes))])})],2)]),_vm._v(" "),_c('b-col',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.anio),expression:"anio"}],staticClass:"form-control redondo-derecho",attrs:{"data-testid":"form-fecha-anio","id":"anio"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.anio=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.limpiarError('fecha');
                _vm.validarFechaCompleta();}]}},[_c('option',{attrs:{"value":"null","disabled":""}},[_vm._v("Año")]),_vm._v(" "),_vm._l((_vm.anios),function(anio){return _c('option',{key:("anio-" + anio),domProps:{"value":anio}},[_vm._v(_vm._s(anio))])})],2)])],1),_vm._v(" "),_c('span',{staticClass:"mensaje-error"},[_vm._v(_vm._s(this.mensajeError("fecha")))])]),_vm._v(" "),_c('b-col',{staticClass:"mt-3",attrs:{"cols":"12","md":"4"}},[_c('InputWrapperSerie',{attrs:{"negrita":"false","grande":"false","state":this.tieneError('serie'),"mensajeError":this.mensajeError('serie')},on:{"~keyup":function($event){return _vm.modificado.push('serie')},"change":_vm.validarSerie,"keyup":_vm.formatoSerie},model:{value:(_vm.serie),callback:function ($$v) {_vm.serie=$$v},expression:"serie"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mt-3 borde-grupo",attrs:{"cols":"12","md":"6"}},[_c('InputTextWrapper',{attrs:{"data-testing":"form-correo-","etiqueta":"Correo electrónico","type":"email","prepend":"true","icono":"true","placeholder":"ejemplo@correo.com","estado":this.tieneError('correo'),"mensajeError":this.mensajeError('correo'),"maxlength":"50","onCopy":"return false","onPaste":"return false"},on:{"~keyup":function($event){return _vm.modificado.push('correo')},"change":function($event){return _vm.validarCorreo('correo', _vm.form.correoElectronico)}},model:{value:(_vm.form.correoElectronico),callback:function ($$v) {_vm.$set(_vm.form, "correoElectronico", $$v)},expression:"form.correoElectronico"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mt-3 borde-grupo",attrs:{"cols":"12","md":"6"}},[_c('InputTextWrapper',{attrs:{"data-testing":"form-correo-confirm","etiqueta":"Confirma correo electrónico","type":"email","prepend":"true","icono":"true","placeholder":"ejemplo@correo.com","estado":this.tieneError('correo2'),"mensajeError":this.mensajeError('correo2'),"maxlength":"50","onCopy":"return false","onPaste":"return false"},on:{"~keyup":function($event){return _vm.modificado.push('correo2')},"keyup":function($event){return _vm.validarCorreo('correo2', _vm.correo2)}},model:{value:(_vm.correo2),callback:function ($$v) {_vm.correo2=$$v},expression:"correo2"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mt-3 borde-grupo",attrs:{"cols":"12","md":"6"}},[_c('InputTextWrapper',{attrs:{"data-testing":"form-telefono","etiqueta":"Número de teléfono móvil","prepend":"true","textInputgroup":"+56 9","estado":this.tieneError('telefono'),"mensajeError":this.mensajeError('telefono'),"maxlength":"9","onCopy":"return false","onPaste":"return false"},on:{"~keyup":function($event){return _vm.modificado.push('telefono')},"change":function($event){return _vm.validarTelefono('telefono', _vm.form.telefonoMovil)}},model:{value:(_vm.form.telefonoMovil),callback:function ($$v) {_vm.$set(_vm.form, "telefonoMovil", $$v)},expression:"form.telefonoMovil"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mt-3 borde-grupo",attrs:{"cols":"12","md":"6"}},[_c('InputTextWrapper',{attrs:{"data-testing":"form-telefono-confirm","etiqueta":"Confirma tu número de teléfono móvil","prepend":"true","textInputgroup":"+56 9","estado":this.tieneError('telefono2'),"mensajeError":this.mensajeError('telefono2'),"maxlength":"9","onCopy":"return false","onPaste":"return false"},on:{"~keyup":function($event){return _vm.modificado.push('telefono2')},"keyup":function($event){return _vm.validarTelefono('telefono2', _vm.telefono2)}},model:{value:(_vm.telefono2),callback:function ($$v) {_vm.telefono2=$$v},expression:"telefono2"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mt-3",attrs:{"cols":"12","md":"6"}},[_c('InputPasswordWrapper',{attrs:{"data-testid":"form-password","negrita":"false","grande":"false","etiqueta":"Ingresa una contraseña","estado":this.tieneError('password'),"mensajeError":this.mensajeError('password'),"maxlength":"50","onCopy":"return false","onPaste":"return false"},on:{"~keyup":function($event){return _vm.modificado.push('password')},"change":function($event){return _vm.validarPassword('password', _vm.form.clave)}},model:{value:(_vm.form.clave),callback:function ($$v) {_vm.$set(_vm.form, "clave", $$v)},expression:"form.clave"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mt-3",attrs:{"cols":"12","md":"6"}},[_c('InputPasswordWrapper',{attrs:{"data-testid":"form-password-confirm","negrita":"false","grande":"false","etiqueta":"Confirma la contraseña","estado":this.tieneError('password2'),"mensajeError":this.mensajeError('password2'),"maxlength":"50","onCopy":"return false","onPaste":"return false"},on:{"~keyup":function($event){return _vm.modificado.push('password2')},"keyup":function($event){return _vm.validarPassword('password2', _vm.password2)}},model:{value:(_vm.password2),callback:function ($$v) {_vm.password2=$$v},expression:"password2"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"mx-auto text-azul pt-4",attrs:{"cols":"12","lg":"7"}},[_c('div',{staticClass:"form-check pb-1"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.terminos),expression:"terminos"}],attrs:{"data-testid":"form-check-terminos","type":"checkbox","name":"radio1","id":"radio1","value":"option1"},domProps:{"checked":Array.isArray(_vm.terminos)?_vm._i(_vm.terminos,"option1")>-1:(_vm.terminos)},on:{"change":[function($event){var $$a=_vm.terminos,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="option1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.terminos=$$a.concat([$$v]))}else{$$i>-1&&(_vm.terminos=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.terminos=$$c}},_vm.validarChecboxes]}}),_vm._v(" "),_c('span',{staticClass:"label-text font-weight-bold"},[_vm._v("\n            He leído y acepto\n            "),_c('a',{staticClass:"text-azul-medio subrayado",attrs:{"href":"https://cdnsae.mineduc.cl/docs/Terminos_y_condiciones_sistema_admision.pdf","target":"_blank","data-testid":"enlace-descarga-terminos-condiciones"}},[_vm._v("términos y condiciones")]),_vm._v("\n            del proceso de admisión\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"form-check pb-1"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocolo),expression:"protocolo"}],attrs:{"data-testid":"form-check-protocolo","type":"checkbox","name":"radio2","id":"radio2","value":"option1"},domProps:{"checked":Array.isArray(_vm.protocolo)?_vm._i(_vm.protocolo,"option1")>-1:(_vm.protocolo)},on:{"change":[function($event){var $$a=_vm.protocolo,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="option1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.protocolo=$$a.concat([$$v]))}else{$$i>-1&&(_vm.protocolo=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.protocolo=$$c}},_vm.validarChecboxes]}}),_vm._v(" "),_c('span',{staticClass:"label-text font-weight-bold"},[_vm._v("\n            He leído y acepto el protocolo de\n            "),_c('a',{staticClass:"text-azul-medio subrayado",attrs:{"href":"https://cdnsae.mineduc.cl/docs/protocolo_de_datos.pdf","target":"_blank","data-testid":"enlace-descarga-terminos-condiciones"}},[_vm._v("manejo de datos")])])])]),_vm._v(" "),(_vm.checboxError)?_c('div',{staticClass:"mensaje-error"},[_vm._v("\n        Para continuar:\n        "),(_vm.checboxError)?_c('ul',[(!_vm.terminos)?_c('li',[_vm._v(_vm._s(this.mensajeError("terminos")))]):_vm._e(),_vm._v(" "),(!_vm.protocolo)?_c('li',[_vm._v(_vm._s(this.mensajeError("protocolo")))]):_vm._e()]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('b-col',{staticClass:"text-center mt-4",attrs:{"cols":"12","lg":"12"}},[(_vm.captchaHabilitado)?_c('InvisibleRecaptcha',{staticClass:"btn btn-lg btn-azul-oscuro2 gilmer text-capitalize px-5 mb-5 font-weight-bold",attrs:{"id":"enviar-form-captcha","data-test":"button-registrar","sitekey":_vm.siteKey,"validate":_vm.validarFormulario,"callback":_vm.recaptachaCallback,"theme":"light","disabled":false,"type":"submit"}},[_vm._v("Registrarme")]):_vm._e(),_vm._v(" "),(!_vm.captchaHabilitado)?_c('button',{staticClass:"btn btn-lg btn-azul-oscuro2 gilmer text-capitalize px-5 font-weight-bold mb-4",attrs:{"data-test":"button-registrar","id":"enviar-form"},on:{"click":function($event){$event.preventDefault();return _vm.pruebaAutomatizada.apply(null, arguments)}}},[_vm._v("\n        Registrarme\n      ")]):_vm._e()],1)],1),_vm._v(" "),(_vm.etapaProceso === 'REGISTRO')?_c('Modal',{ref:"modalExitoso",attrs:{"tituloMensaje":"Registro Exitoso","mensaje":"Ya estás registrado/a, <strong>recuerda que debes postular en la fecha que corresponda.</strong> Mientras tanto, puedes revisar los establecimientos disponibles.","tipoModal":"EXITO","destino":"Vitrina","textoBoton":"Ver establecimientos"}}):_c('Modal',{ref:"modalExitoso",attrs:{"tituloMensaje":"Registro Exitoso","mensaje":"Ya puedes acceder al Sistema de Admisión Escolar.","destino":"Inicio","tipoModal":"EXITO","textoBoton":"Iniciar Sesión"}}),_vm._v(" "),_c('Modal',{ref:"modalApoderadoNoValido",attrs:{"tituloMensaje":"NO ESTAS VINCULADO(A) A UN ESTUDIANTE.","mensaje":"<span class='text-azul'>\n                Si tienes más de 18 años, solicita la vinculación como apoderado(a) en \n                <a href='https://www.ayudamineduc.cl/tema/54953#55561' target='_blank' style='text-decoration: underline;  font-weight: bold;'>Ayuda Mineduc.</a>\n            </span><br/><br/>\n            <span class='text-azul'>\n              <strong><i>Mientras gestionas tu solicitud, conoce todos los colegios disponibles a los que puedes postular </i></strong> \n              <br><a href='/vitrina-vue' target='_self' style='text-decoration: underline;  font-weight: bold;'>VER ESTABLECIMIENTOS</a>\n            </span>","ayudaMieduc":false,"destino":"Inicio","tipoModal":"ALERTA","textoBoton":"Ir a la página Inicio"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KN05":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ApiDirectorio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Errores__ = __webpack_require__("LQJy");



var _this = this;




var ApiDirectorio = {
  obtenerInformacion: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(componente, tokenBearer) {
      var response, parametros, resultadoEtapa;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://apisae.mineduc.cl/sae-api-directorios/v1/private/" + "parametrosGenerales/", {
                headers: {
                  Authorization: "Bearer " + tokenBearer
                }
              });

            case 3:
              response = _context.sent;

              if (!response.data) {
                _context.next = 28;
                break;
              }

              parametros = response.data.reduce(function (acc, elemento) {
                acc[elemento.llave] = elemento;
                return acc;
              }, {});
              resultadoEtapa = "";

              if (!parametros.etapa) {
                _context.next = 26;
                break;
              }

              _context.t0 = parametros.etapa.valor;
              _context.next = _context.t0 === "0" ? 11 : _context.t0 === "1" ? 13 : _context.t0 === "2" ? 15 : _context.t0 === "3" ? 17 : _context.t0 === "4" ? 19 : _context.t0 === "5" ? 21 : 23;
              break;

            case 11:
              resultadoEtapa = "REGISTRO_ANTICIPADO";
              return _context.abrupt("break", 23);

            case 13:
              resultadoEtapa = "POSTULACION";
              return _context.abrupt("break", 23);

            case 15:
              resultadoEtapa = "NORMAL";
              return _context.abrupt("break", 23);

            case 17:
              resultadoEtapa = "LISTA_DE_ESPERA";
              return _context.abrupt("break", 23);

            case 19:
              resultadoEtapa = "COMPLEMENTARIO";
              return _context.abrupt("break", 23);

            case 21:
              resultadoEtapa = "RESULTADO_FINAL";
              return _context.abrupt("break", 23);

            case 23:
              return _context.abrupt("return", {
                parametroModoRecuperarPassword: parametros.modoRecuperarPassword,
                parametroRecaptchaHabilitado: parametros.recaptchaHabilitado,
                parametroAnioPostulacion: parametros.anioPostulacion,
                parametroAnioAdmision: parametros.anioAdmision,
                parametroInicioPostulacion: parametros.inicioPostulacion,
                parametroFinPostulacion: parametros.finPostulacion,
                parametroFechaPeriodoComplementario: parametros.fechaPeriodoComplementario,
                parametroFechaListaEspera: parametros.fechaListaEspera,
                parametroFechaResultadosFinales: parametros.fechaResultadosFinales,
                parametroAnioSiguiente: parametros.anioSiguiente,
                parametroAnioAnterior: parametros.anioAnterior,
                parametroAnioIndicadorCatDesempenioBasica: parametros.anioIndicadorCatDesempenioBasica,
                parametroAnioIndicadorCatDesempenioMedia: parametros.anioIndicadorCatDesempenioMedia,
                parametroAnioIndicadorCatSimceBasica: parametros.anioIndicadorCatSimceBasica,
                parametroAnioIndicadorCatSimceMedia: parametros.anioIndicadorCatSimceMedia,
                parametroAnioIndicadorCatDesarrolloBasica: parametros.anioIndicadorCatDesarrolloBasica,
                parametroAnioIndicadorCatDesarrolloMedia: parametros.anioIndicadorCatDesarrolloMedia,
                parametroMostrarVacantes: parametros.mostrarVacantes,
                parametroMostrarProcedimientosEspeciales: parametros.mostrarProcedimientosEspeciales,
                parametroModoEnvioCorreo: parametros.modoEnvioCorreo,
                resultadoEtapa: resultadoEtapa
              });

            case 26:
              console.error("Respuesta de API incorrecta");
              return _context.abrupt("return", null);

            case 28:
              _context.next = 35;
              break;

            case 30:
              _context.prev = 30;
              _context.t1 = _context["catch"](0);

              __WEBPACK_IMPORTED_MODULE_3__utils_Errores__["a" /* default */].switchErrors(_context.t1, componente);
              console.error("Error al cargar parámetros iniciales:", _context.t1.response || _context.t1.message || _context.t1);
              return _context.abrupt("return", null);

            case 35:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 30]]);
    }));

    return function obtenerInformacion(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }()
};

/* harmony default export */ __webpack_exports__["a"] = (ApiDirectorio);

/***/ }),

/***/ "KeMu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.arriba)?_c('b-button',{staticClass:"myBtn btn-azul-medio border border-light d-xl-none",on:{"click":_vm.scrollToTop}},[_c('FontAwesomeIcon',{staticClass:"h5 mb-0",attrs:{"icon":"angle-up"}})],1):_vm._e(),_vm._v(" "),(!_vm.mueve)?_c('section',{staticClass:"demo border bg-azul d-md-none",attrs:{"id":"flecha-abajo"},on:{"scroll":_vm.handleScroll}},[_vm._m(0)]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-degrade-blanco w-100 fixed-bottom py-5"},[_vm._v("\n       \n      "),_c('a',[_c('span')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L5Hh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"recuperar-contrasena"}},[_c('Volver',{attrs:{"redireccion":"OlvidoContrasena"}}),_vm._v(" "),_c('Titulo',{attrs:{"subtitulo":"Ingresa el código de seguridad enviado a tu medio de contacto registrado en la plataforma"}},[_c('b-col',{staticClass:"mt-3",attrs:{"cols":"12","md":"6","order":"0"}},[_c('label',{staticClass:"mb-1 font-weight-bold"},[_vm._v("Código de seguridad")]),_vm._v(" "),_c('b-form-input',{staticClass:"form-control-lg placeholder",attrs:{"data-testid":"form-codigo-validacion","type":"text","state":_vm.tieneError('codigo'),"trim":"","autocomplete":"off"},on:{"~keyup":function($event){return _vm.modificado.push('codigo')},"change":function($event){return _vm.validarCodigoValid()}},model:{value:(_vm.codigoValidacion),callback:function ($$v) {_vm.codigoValidacion=$$v},expression:"codigoValidacion"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.mensajeError("codigo")))])],1),_vm._v(" "),_c('b-col',{staticClass:"mt-4 mt-lg-3",attrs:{"cols":"12","md":"6","order":"2","order-lg":"1"}},[_c('InputPasswordWrapper',{attrs:{"dataTestid":"form-clave-nueva","etiqueta":"Ingresa una nueva contraseña","negrita":"true","grande":"true","maxlength":"50","estado":this.tieneError('password'),"mensajeError":this.mensajeError('password'),"onCopy":"return false","onPaste":"return false"},on:{"~keyup":function($event){return _vm.modificado.push('password', 'password2')},"change":function($event){return _vm.validarPassword('password', _vm.recuperar.clave)}},model:{value:(_vm.recuperar.clave),callback:function ($$v) {_vm.$set(_vm.recuperar, "clave", $$v)},expression:"recuperar.clave"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mt-2 text-gris",attrs:{"cols":"12","md":"6","order":"1","order-lg":"2"}},[_vm._v("Código de seguridad enviado al medio de contacto registrado en la\n      plataforma")]),_vm._v(" "),_c('b-col',{staticClass:"mt-4",attrs:{"cols":"12","md":"6","order":"3"}},[_c('InputPasswordWrapper',{attrs:{"dataTestid":"form-clave-confirmar","etiqueta":"Confirmar la nueva contraseña","negrita":"true","grande":"true","maxlength":"50","estado":this.tieneError('password2'),"mensajeError":this.mensajeError('password2'),"onCopy":"return false","onPaste":"return false"},on:{"~keyup":function($event){return _vm.modificado.push('password2')},"keyup":function($event){return _vm.validarPassword('password2', _vm.confirmarClave)}},model:{value:(_vm.confirmarClave),callback:function ($$v) {_vm.confirmarClave=$$v},expression:"confirmarClave"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mb-2 mt-3 mt-lg-5 px-0 px-lg-3 text-center mb-5",attrs:{"cols":"12","order":"4"}},[_c('button',{staticClass:"btn-lg btn-azul-oscuro2 gilmer text-left pr-3 mt-2 text-uppercase px-4 font-weight-bold",attrs:{"data-testid":"button-cambiar-clave","id":"enviar-form"},on:{"click":function($event){_vm.validarFomulario() ? _vm.enviarFormualrio() : false}}},[_vm._v("\n        Cambiar contraseña\n      ")]),_vm._v(" "),_c('div',{staticClass:"mt-4 text-gris",attrs:{"md":"6"}},[_vm._v("\n        En caso de no recibir el código de seguridad contactarse al 600 600\n        2626\n      ")])])],1),_vm._v(" "),_c('Modal',{ref:"modalExitoso",attrs:{"tituloMensaje":"Cambio de clave exitoso","mensaje":"Ya puedes acceder al Sistema de Admisión Escolar.","destino":"Inicio","tipoModal":"EXITO","textoBoton":"Ir a Página de inicio "}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LQJy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var switchErrors = function switchErrors(error, componente) {
  var excepciones = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var mensaje = "";
  var titulo = "";
  var tipo = "onError";
  var dobleBotonera = false;
  var ayuda = false;
  var codigo = null;
  var excepcion = null;
  if (error && (error.data || error.response || error.status)) {
    if (excepciones.length > 0) {
      var codigoError = error.status || error.response.status;
      excepcion = excepciones.find(function (excepcionTemp) {
        return "" + excepcionTemp.codigo === "" + codigoError;
      });
      if (excepcion) {
        mensaje = excepcion.mensaje;
        codigo = excepcion.codigo;
        if (codigo == 503) {
          tipo = "onAlerta";
          titulo = "";
        }
      }
    }
    if (!excepcion) {
      switch (error.status || error.response.status) {
        case 204:
          titulo = "Registro fallido";
          mensaje = "Por favor intenta de nuevo";
          break;
        case 401:
          if (error.data && error.data.errores) {
            var values = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(error.data.errores).map(function (key) {
              return dictionary[key];
            });
            mensaje = values[0];
          } else if (error.response && error.response.data) {
            if (error.response.data.errors) {
              mensaje = error.response.data.errors[0].defaultMessage;
            } else if (error.response.data.intentosRestantes > 0) {
              mensaje = "Contraseña incorrecta, intentos restantes: " + error.response.data.intentosRestantes;
            } else if (error.response.data && error.response.data.intentosRestantes == 0) {
              mensaje = "Ha superado los intentos para ingresar su contraseña. Vaya a la sección “Olvidé mi contraseña” para recuperarla.";
            } else if (error.response.data && error.response.data.intentosRestantes == undefined) {
              mensaje = "Asegurate de ingresar tu RUN con guión y dígito verificador, y tu contraseña exactamente como la registraste.";
            }
          }
          break;
        case 406:
          titulo = "Error para Iniciar Sesión";
          mensaje = "Asegurate de ingresar tu RUN con guión y dígito verificador, y tu contraseña exactamente como la registraste.";
          break;
        case 404:
          titulo = "No encontrado";
          tipo = "onAlerta";
          mensaje = "Los datos no han sido encontrados, por favor recargar la página y reintentar";
          break;
        case 400:
          if (error.data && error.data.errores) {
            var _values = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(error.data.errores).map(function (key) {
              return dictionary[key];
            });
            mensaje = _values[0];
          } else if (error.response && error.response.data) {
            if (error.response.data.errors) {
              mensaje = error.response.data.errors[0].defaultMessage;
            } else if (error.response.data.errores) {
              var _values2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(error.response.data.errores).map(function (key) {
                return error.response.data.errores[key][0];
              });
              mensaje = _values2[0];
            }
            var idx = mensaje.indexOf("recuperar contraseña");
            if (idx != -1) {
              codigo = 700;
            }
          }
          break;
        case 409:
          titulo = "Este RUN ya está registrado";
          tipo = "onAlerta";
          mensaje = "Si recuerdas tu clave Inicia sesión, de lo contrario recupera tu contraseña";
          dobleBotonera = true;
          break;
        case 500:
          titulo = "Error";
          if (componente.$el.id === "Inicio") {
            mensaje = "No se ha podido ingresar al sistema de admisión, por favor intentar de nuevo.";
          } else if (componente.$el.id === "Registro") {
            titulo = "Registro fallido";
            tipo = "onAlerta";
            mensaje = "Por favor intenta de nuevo";
          } else {
            mensaje = "No se ha podido realizar la operación, por favor intentar de nuevo.";
            ayuda = true;
          }
          break;
        case 503:
          titulo = "El sistema está teniendo alta demanda";
          mensaje = "No te preocupes, vuelve a intentarlo más tarde. <br>Mientras, revisa los colegios a los que postularás.<br><a href='/vitrina-vue' target='_self' style='text-decoration: underline;  font-weight: bold;'>VER ESTABLECIMIENTOS</a>";
          break;
        default:
          titulo = "El sistema está teniendo alta demanda";
          mensaje = "No te preocupes, vuelve a intentarlo más tarde. <br>Mientras, revisa los colegios a los que postularás.<br><a href='/vitrina-vue' target='_self' style='text-decoration: underline;  font-weight: bold;'>VER ESTABLECIMIENTOS</a>";
      }
    }
  } else {
    if (error.message) {
      mensaje = error.message;
    } else {
      mensaje = "No te preocupes, vuelve a intentarlo más tarde. Mientras, revisa los colegios a los que postularás. <a href='/vitrina-vue' target='_self' style='text-decoration: underline;  font-weight: bold;'> VER ESTABLECIMIENTOS</a>";
    }
  }
  if (mensaje.length > 0) {
    componente.$emit(tipo, mensaje, titulo, dobleBotonera, ayuda, codigo);
  } else {
    console.warn("Error sin mensaje");
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ switchErrors: switchErrors });

/***/ }),

/***/ "LfIW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"cols":"12","md":"12","lg":"6","sm":"12","order":"0","order-md":"0"}},[_c('div',{staticClass:"h6 text-justify rounded text-white px-4 py-3 bg-azul-medio w-100 mt-4"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"m-1 h5 mb-5"},[_vm._v("\n          Si tu estudiante\n          "),_c('strong',[_vm._v("\n            ingresará por primera vez al sistema escolar o necesita cambiarse\n            de establecimiento para el año "+_vm._s(_vm.anioAdmision))]),_vm._v(", deberás postular entre el "+_vm._s(_vm.inicioPostulacion)+" y el\n          "+_vm._s(_vm.finPostulacion)+".\n        ")]),_vm._v(" "),(_vm.noTieneMiercoles)?_c('br'):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"h5 text-justify text-white bg-azul-medio w-100 mt-1"},[_c('ul',{staticClass:"m-1 h5 pl-0"},[_c('li',{staticClass:"font-weight-bold no-bullet h3 text-left mb-4"},[_vm._v("\n          ¡IMPORTANTE ANTES DE POSTULAR!\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Postula solo si necesitas un nuevo establecimiento. Si tu estudiante\n          es asignado en alguna de sus preferencias, perderá el cupo actual\n          que utiliza.​\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Postula al menos 6 establecimientos y ordénalos según tus\n          preferencias. Mientras más postulaciones ingreses, más posibilidades\n          tienes de tener asignación.\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Verifica el curso al que estás postulando para el próximo año\n          escolar.\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Tómate tu tiempo para postular. La asignación considera tus\n          preferencias y los criterios de prioridad. No es por orden de\n          llegada.\n        ")])]),_vm._v(" "),_c('div',{staticClass:"w-100 text-center mt-5"},[_vm._v("\n        Conoce todos los colegios disponibles a los que puedes postular.\n      ")])]),_vm._v(" "),_c('div',{staticClass:"row mx-4 mx-lg-5 mt-4 mb-4"},[_c('router-link',{staticClass:"btn-lg btn-azul-oscuro2 text-uppercase gilmer font-weight-bold w-100",attrs:{"to":{ name: 'Vitrina' }}},[_vm._v("\n        Ver Establecimientos\n      ")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb07a794_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("glzv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb07a794_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MtFV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md order-1 order-md-0"},[_c('div',{staticClass:"text-azul-medio text-uppercase gilmer h4 text-center mt-5 mt-md-3 font-weight-light"},[_vm._v("\n    Acerca del proceso\n  ")]),_vm._v(" "),_c('div',{staticClass:"bg-azul-claro py-4 px-4 h6 text-center rounded"},[_vm._v("\n    Los resultados del proceso de listas de espera de Admisión Escolar estarán\n    disponibles en este portal desde el\n    "),_c('strong',[_vm._v(_vm._s(_vm.fechaListaEspera))]),_vm._v(" "),_c('img',{staticClass:"img-fluid my-4",attrs:{"src":"https://cdnsaemineduc.s3.us-east-1.amazonaws.com/img/fechas.svg","width":"260","alt":""}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"bg-azul-claro py-3 px-4 h6 text-center rounded mt-5 mt-lg-3"},[_c('a',{staticClass:"gilmer h5 font-weight-light",attrs:{"href":_vm.ayuda,"data-testid":"enlace-ayuda-mineduc","target":"_blank"}},[_c('strong',{staticClass:"d-inline-block"},[_vm._v("¿Dudas con tus resultados?")]),_vm._v(" "),_c('span',{staticClass:"d-inline-block mt-2 text-uppercase font-weight-bold subrayado h6"},[_vm._v("Consulta Ayuda Mineduc")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-azul-medio rounded py-4 text-white gilmer mx-0 mx-lg-3"},[_vm._v("\n      Accede con el mismo\n      "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("USUARIO")]),_vm._v(" y\n      "),_c('strong',[_vm._v("CONTRASEÑA")]),_vm._v(" "),_c('br'),_vm._v("del proceso de postulación\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__("Tqaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__("qb6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_storage_watcher__ = __webpack_require__("CZUA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_storage_watcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_storage_watcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_gtag__ = __webpack_require__("Z3T5");








__webpack_require__("NriV");

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_storage_watcher___default.a, { prefix: "admis_", storage: "session" });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_gtag__["a" /* default */], {
  config: {
    id: "G-X92BTQ7YF5"
  }
}, __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: "#app",
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: "<App/>",
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "NRXF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md order-1 order-md-0"},[_c('div',{staticClass:"text-azul-medio text-uppercase gilmer h4 text-center mt-5 mt-md-3 font-weight-light"},[_vm._v("\n    Acerca del proceso\n  ")]),_vm._v(" "),_c('div',{staticClass:"bg-azul-claro py-4 px-4 h6 text-center rounded"},[_vm._v("\n    Los\n    "),_c('strong',[_vm._v("resultados de listas de espera")]),_vm._v(" del proceso de Admisión\n    Escolar están disponibles en este portal los días\n    "),_c('strong',[_vm._v(_vm._s(_vm.fechaListaEspera))]),_vm._v(" "),_c('img',{staticClass:"img-fluid my-4 d-block mx-auto",attrs:{"src":"https://cdnsaemineduc.s3.us-east-1.amazonaws.com/img/calendario-lista-de-espera.svg","width":"170","alt":""}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"bg-azul-claro py-3 px-4 h6 text-center rounded mt-5 mt-lg-3"},[_c('a',{staticClass:"gilmer h5 font-weight-light",attrs:{"href":_vm.ayuda,"target":"_blank"}},[_c('strong',{staticClass:"d-inline-block"},[_vm._v("¿Dudas con tus resultados?")]),_vm._v(" "),_c('span',{staticClass:"d-inline-block mt-2 text-uppercase font-weight-bold subrayado h6"},[_vm._v("Consulta Ayuda Mineduc")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-azul-medio rounded py-4 text-white gilmer mx-0 mx-lg-3"},[_vm._v("\n      Accede con el mismo\n      "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("USUARIO")]),_vm._v(" y\n      "),_c('strong',[_vm._v("CONTRASEÑA")]),_vm._v(" "),_c('br'),_vm._v("del proceso de postulación\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NcpV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformacionPostulacionComplementaria_vue__ = __webpack_require__("8zks");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78f8deee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformacionPostulacionComplementaria_vue__ = __webpack_require__("BCjB");
function injectStyle (ssrContext) {
  __webpack_require__("wHr2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformacionPostulacionComplementaria_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78f8deee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformacionPostulacionComplementaria_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NriV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OgR5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "InformacionAceptaCondiciones",
  data: function data() {
    return {
      ayuda: "https://www.ayudamineduc.cl/ficha/postulacion-al-sistema-de-admision-escolar",
      etapaProceso: ""
    };
  },
  created: function created() {
    var obtenerValorLocalStorage = function obtenerValorLocalStorage(key) {
      var valorPorDefecto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "----";

      var valor = localStorage.getItem(key);
      return valor ? valor : valorPorDefecto;
    };

    this.etapaProceso = obtenerValorLocalStorage("etapaProceso");
  }
});

/***/ }),

/***/ "PaH+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33e168c1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("1iRa");
function injectStyle (ssrContext) {
  __webpack_require__("j7uu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33e168c1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33e168c1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q5tb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3f75e6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsuarioNoRegistrado_vue__ = __webpack_require__("IocX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3f75e6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsuarioNoRegistrado_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QdUX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SCsV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.etapaCargada)?_c('b-form',{staticClass:"row col-12 mx-auto",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();}}},[_c('b-col',{staticClass:"text-center mb-0",attrs:{"cols":"24","md":"24","lg":"12","sm":"24","order-md":"0"}},[_c('div',{staticClass:"banner"},[_c('p',{staticClass:"banner-text"},[_vm._v("\n        Periodo Principal de postulación para\n        "),_c('strong',{staticStyle:{"font-size":"1.2em"}},[_vm._v("el año escolar "+_vm._s(_vm.anioAdmision))])])])]),_vm._v(" "),(_vm.etapaProceso === 'REGISTRO')?_c('InformacionRegistro'):_vm._e(),_vm._v(" "),(_vm.etapaProceso === 'POSTULACION')?_c('InformacionPostulacion'):_vm._e(),_vm._v(" "),(_vm.etapaProceso === 'REGISTRO_ANTICIPADO')?_c('InformacionPostulacionRegistroAnticipado'):_vm._e(),_vm._v(" "),(_vm.etapaProceso === 'NORMAL')?_c('InformacionResultados'):_vm._e(),_vm._v(" "),(_vm.etapaProceso === 'LISTA_DE_ESPERA')?_c('InformacionListaDeEspera'):_vm._e(),_vm._v(" "),(_vm.etapaProceso === 'COMPLEMENTARIO')?_c('InformacionPostulacionComplementaria'):_vm._e(),_vm._v(" "),(_vm.etapaProceso === 'RESULTADO_FINAL')?_c('InformacionResultadosFinales'):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","md":"12","lg":"6","sm":"12","order-md":"1"}},[_c('div',{staticClass:"text-azul-medio text-uppercase gilmer h5 bg-white mx-0 pt-0 pb-0 font-weight-bold mb-0"},[(_vm.titulo)?_c('span',{domProps:{"textContent":_vm._s(_vm.titulo)}}):_c('span',[_vm._v(" ")])]),_vm._v(" "),(_vm.etapaProceso === 'REGISTRO')?_c('InicioRegistro'):[(
          !['NORMAL', 'LISTA_DE_ESPERA', 'RESULTADO_FINAL'].includes(
            _vm.etapaProceso
          )
        )?_c('div',{staticClass:"h6 text-center rounded text-white px-0 bg-azul-medio w-100 py-3"},[_c('div',{staticClass:"gilmer text-uppercase h5 mx-4 mx-lg-5 mt-4"},[_c('b',[_vm._v("REGISTRO COMO APODERADO(A)")])]),_vm._v(" "),_c('div',{staticClass:"form-group mx-4 mt-4 text-justify m-1 h5"},[_c('span',[_vm._v("\n            Si tienes RUN y no has postulado en años anteriores crea una nueva\n            cuenta con tu carnet de identidad, correo electrónico y teléfono.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group mx-4 mx-lg-5 mt-4 text-left"},[_c('router-link',{staticClass:"btn-lg btn-azul-oscuro2 text-uppercase gilmer font-weight-bold w-100",attrs:{"data-testid":"button-olvido-contrasena","to":"registro","theme":"light","type":"submit"}},[_vm._v("REGISTRARME")])],1),_vm._v(" "),_c('div',{staticClass:"form-group mx-4 mx-lg-5 mt-4 text-left"},[_c('p',{staticClass:"italic-text"},[_vm._v("\n            Si no tienes RUN chileno, obtén tu Identificador provisorio de\n            apoderado(a)\n            "),_c('a',{staticStyle:{"text-decoration":"underline"},attrs:{"href":"https://ayudamineduc.cl/tramites-en-linea","target":"_blank"}},[_vm._v("\n              aquí ")]),_vm._v(".\n            "),_c('br')])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"h6 text-center rounded text-white px-0 bg-azul-medio w-100 py-3 contentHeight"},[_c('div',{staticClass:"gilmer text-uppercase h5"},[(
              ['NORMAL', 'LISTA_DE_ESPERA', 'RESULTADO_FINAL'].includes(
                _vm.etapaProceso
              )
            )?_c('span',[_vm._v("Ingresa para revisar tus resultados")]):(['REGISTRO_ANTICIPADO'].includes(_vm.etapaProceso))?_c('span',[_c('b',[_vm._v("Ingreso de apoderado(a) con cuenta ya registrada.")])]):_c('span',[_vm._v("Ingresa para postular")])]),_vm._v(" "),_c('div',{staticClass:"form-group mx-4 mx-lg-5 mt-4 text-left"},[_c('label',{staticClass:"mb-1",attrs:{"for":"run"}},[_vm._v("RUN/IPA apoderado")]),_vm._v(" "),_c('b-input',{staticClass:"form-control form-control-lg placeholder",attrs:{"data-testid":"run","id":"run","type":"text","placeholder":"21.123.456-1","state":_vm.tieneError('rut'),"maxlength":"13","autocomplete":"off"},on:{"~keyup":function($event){return _vm.modificado.push('rut')},"change":_vm.validarRut,"keyup":_vm.formatoRut},model:{value:(_vm.rut),callback:function ($$v) {_vm.rut=$$v},expression:"rut"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorRut),expression:"errorRut"}],staticClass:"mensaje-error"},[_vm._v("\n            "+_vm._s(this.mensajeError("rut"))+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"form-group mx-4 mx-lg-5 mt-4 text-left"},[_c('label',{staticClass:"mb-1",attrs:{"for":"password"}},[_vm._v("Contraseña")]),_vm._v(" "),_c('b-input',{staticClass:"form-control form-control-lg placeholder",attrs:{"data-testid":"clave","id":"password","type":"password","placeholder":"Contraseña","state":this.tieneError('pass'),"autocomplete":"off"},on:{"~keyup":function($event){return _vm.modificado.push('pass')},"change":function($event){return _vm.validarPassword('pass', _vm.usuario.clave)}},model:{value:(_vm.usuario.clave),callback:function ($$v) {_vm.$set(_vm.usuario, "clave", $$v)},expression:"usuario.clave"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorPass),expression:"errorPass"}],staticClass:"mensaje-error"},[_vm._v("\n            "+_vm._s(this.mensajeError("pass"))+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"d-block mx-4 mx-lg-5 mt-3 mb-4"},[(_vm.captchaHabilitado)?_c('InvisibleRecaptcha',{staticClass:"btn-lg btn-azul-oscuro2 text-uppercase gilmer font-weight-bold w-100",attrs:{"data-test":"button-login-captcha","id":"logincapcha","sitekey":_vm.siteKey,"validate":_vm.validarCredenciales,"callback":_vm.captcha,"theme":"light","type":"submit"}},[_vm._v("Ingresar")]):_vm._e(),_vm._v(" "),(!_vm.captchaHabilitado)?_c('button',{staticClass:"btn-lg btn-azul-oscuro2 text-uppercase gilmer font-weight-bold w-100",attrs:{"data-testid":"button-login","id":"login","type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.pruebaAutomatizada.apply(null, arguments)}}},[_vm._v("\n            Ingresar\n          ")]):_vm._e(),_vm._v(" "),_c('div',[_c('p',{staticClass:"italic-text mt-1 texto_lefted"},[_vm._v("\n              Si tienes un Identificador Provisorio de Apoderado (IPA) la\n              contraseña será el número de IPA sin puntos ni dígito\n              verificador. Por ejemplo si el IPA es 200.123.456-7, la\n              contraseña será 200123456.\n            ")])]),_vm._v(" "),_c('router-link',{staticClass:"font-weight-bold text-white subrayado",attrs:{"data-testid":"button-olvido-contrasena","to":"olvido-contrasena"}},[_vm._v("Olvidé mi contraseña.")])],1),_vm._v(" "),(_vm.claveunica)?_c('div',{staticClass:"w-100 texto-centro"},[_c('span',{staticStyle:{"display":"block","margin":"30px 5px","font-family":"sans-serif"}},[_vm._v("Si ya tienes cuenta, recuerda que puedes ingresar con clave\n            única")]),_vm._v(" "),_c('a',{staticClass:"btn-cu",on:{"click":_vm.cargarClaveUnica}},[_c('span',{staticClass:"cl-claveunica"}),_vm._v(" "),_c('span',{staticClass:"texto"},[_vm._v("Iniciar sesión")])])]):_vm._e()])]],2)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SZVz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__ = __webpack_require__("C/JF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_free_solid_svg_icons__ = __webpack_require__("fhbW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__("1e6/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_1__fortawesome_free_solid_svg_icons__["b" /* faCheck */]);
__WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_1__fortawesome_free_solid_svg_icons__["c" /* faTimesCircle */]);
__WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_1__fortawesome_free_solid_svg_icons__["d" /* faExclamationCircle */]);
__WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_1__fortawesome_free_solid_svg_icons__["e" /* faExclamationTriangle */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["mensaje", "tituloMensaje", "destino", "textoBoton", "tipoModal", "botoneraDoble", "ayudaMieduc", "recuperarContrasenia"],
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__["a" /* FontAwesomeIcon */]
  },
  computed: {
    tituloModalPersonalizado: function tituloModalPersonalizado() {
      if (this.recuperarContrasenia) {
        return "Ya tienes una cuenta registrada";
      }
      return this.tituloMensaje;
    }
  },
  watch: {
    // Si cambiamos de página, cerramos el mensaje de carga
    $route: function $route() {
      this.hideModal();
    }
  },
  methods: {
    showModal: function showModal() {
      this.$refs["my-modal"].show();
    },
    hideModal: function hideModal() {
      this.$refs["my-modal"].hide();
    }
  }
});

/***/ }),

/***/ "UuG9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generales_inputs_InputTextWrapper__ = __webpack_require__("xEUv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generales_inputs_InputPasswordWrapper__ = __webpack_require__("GDUu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_meses__ = __webpack_require__("EKLV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_js_formatoRut__ = __webpack_require__("c4fo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_js_manejoErrores__ = __webpack_require__("xdtW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_js_validador__ = __webpack_require__("J7t/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_ApiRegistro__ = __webpack_require__("ZZ9v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_generales_recaptcha_InvisibleRecaptcha__ = __webpack_require__("VdD7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_generales_modales_Mensaje__ = __webpack_require__("58OK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_generales_inputs_InputWrapperSerie__ = __webpack_require__("Fk90");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_generales_Volver__ = __webpack_require__("hP5U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_generales_TituloRegistro__ = __webpack_require__("INPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fortawesome_fontawesome_svg_core__ = __webpack_require__("C/JF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__fortawesome_free_solid_svg_icons__ = __webpack_require__("fhbW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__fortawesome_vue_fontawesome__ = __webpack_require__("1e6/");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















__WEBPACK_IMPORTED_MODULE_14__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_15__fortawesome_free_solid_svg_icons__["j" /* faEnvelope */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__assets_js_manejoErrores__["a" /* manejoErrores */]],
  components: {
    InputTextWrapper: __WEBPACK_IMPORTED_MODULE_2__components_generales_inputs_InputTextWrapper__["a" /* default */],
    InputPasswordWrapper: __WEBPACK_IMPORTED_MODULE_3__components_generales_inputs_InputPasswordWrapper__["a" /* default */],
    InvisibleRecaptcha: __WEBPACK_IMPORTED_MODULE_9__components_generales_recaptcha_InvisibleRecaptcha__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_10__components_generales_modales_Mensaje__["a" /* default */],
    InputWrapperSerie: __WEBPACK_IMPORTED_MODULE_11__components_generales_inputs_InputWrapperSerie__["a" /* default */],
    Volver: __WEBPACK_IMPORTED_MODULE_12__components_generales_Volver__["a" /* default */],
    Titulo: __WEBPACK_IMPORTED_MODULE_13__components_generales_TituloRegistro__["a" /* default */]
  },
  data: function data() {
    return {
      form: {
        run: "",
        digitoVerificador: "",
        fechaDeNacimiento: "",
        cow: "",
        correoElectronico: "",
        telefonoMovil: "",
        clave: "",
        requiereInformacionProcesosEspeciales: false
      },
      config: {
        headers: {},
        params: {}
      },
      rut: "",
      serie: "",
      dia: null,
      mes: null,
      anio: null,
      correo2: "",
      telefono2: "",
      password2: "",
      meses: __WEBPACK_IMPORTED_MODULE_4__assets_js_meses__["a" /* default */].meses,
      anios: this.listarAnios(),
      checboxError: false,
      mediosContactoError: false,
      siteKey: "6LfE9rYqAAAAACUgAep0DVg4Nzpk4DQmnq1VlEy-",
      terminos: null,
      protocolo: null,
      tituloMensajeModal: "",
      mensajeModal: "",
      etapaProceso: null,
      tramite: true, //Borrar propiedad una vez corroborado que el tramite si salio
      captchaHabilitado: localStorage.getItem("recatpchaHabilitado") || "true"
    };
  },
  beforeCreated: function beforeCreated() {
    var etapaProceso = localStorage.getItem("etapaProceso");
  },

  methods: {
    //ELIMINAR ANTES DE PRODUCCION
    pruebaAutomatizada: function pruebaAutomatizada() {
      var formValido = this.validarFormulario();
      if (formValido) {
        this.config.headers = {
          "g-recaptcha-response": "recaptchaToken"
        };
        this.config.params = {
          tipoCaptcha: "INVISIBLE"
        };
        this.form.correoElectronico = this.form.correoElectronico.toLowerCase();
        this.correo2 = this.correo2.toLowerCase();
        this.enviarFormulario();
      }
    },

    //ELIMINAR ANTES DE PRODUCCION
    recaptachaCallback: function recaptachaCallback(recaptchaToken) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!recaptchaToken) {
                  _context.next = 5;
                  break;
                }

                _this.config.headers = {
                  "g-recaptcha-response": recaptchaToken
                };
                _this.config.params = {
                  tipoCaptcha: "INVISIBLE"
                };
                _context.next = 5;
                return _this.enviarFormulario();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    validarVacio: function validarVacio(campo, valor) {
      var valido = true;
      this.limpiarError(campo);
      if (valor.length < 1) {
        this.guardarError(campo, "Campo obligatorio");
        valido = false;
      }
      return valido;
    },
    validarCorreo: function validarCorreo(campo, valor) {
      var valido = true;
      this.limpiarError(campo);
      if (valor.length >= 1) {
        if (!__WEBPACK_IMPORTED_MODULE_7__assets_js_validador__["a" /* default */].validarExpresion("correo", valor)) {
          this.guardarError(campo, "El correo electrónico no es válido");
          valido = false;
        } else if (this.validarMediosContacto()) {
          this.limpiarErroresMediosContacto();
        }
      }
      return valido;
    },
    validarRut: function validarRut() {
      var valido = true;
      var valor = this.rut;
      this.limpiarError("run");
      valido = this.validarVacio("run", valor);
      if (valido) {
        if (!__WEBPACK_IMPORTED_MODULE_7__assets_js_validador__["a" /* default */].validarExpresion("rut", valor) || !__WEBPACK_IMPORTED_MODULE_5__assets_js_formatoRut__["a" /* default */].digitoVerificador(valor)) {
          this.guardarError("run", "El Run no es válido");
          valido = false;
        }
      }
      if (valido) {
        this.form.run = parseInt(valor.slice(0, -1).split(".").join("").replace("-", ""));
        this.form.digitoVerificador = valor.substr(valor.length - 1);
      }
      return valido;
    },
    validarTelefono: function validarTelefono(campo, valor) {
      var valido = true;
      this.limpiarError(campo);
      if (valor.length >= 1) {
        if (!__WEBPACK_IMPORTED_MODULE_7__assets_js_validador__["a" /* default */].validarExpresion("telefono", valor)) {
          this.guardarError(campo, "El número de telefóno no es válido");
          valido = false;
        } else if (__WEBPACK_IMPORTED_MODULE_7__assets_js_validador__["a" /* default */].validarExpresion("telefono-longitud", valor)) {
          this.guardarError(campo, "Debe ingresar sólo los 8 últimos digitos de su teléfono móvil");
          valido = false;
        } else if (this.validarMediosContacto()) {
          this.limpiarErroresMediosContacto();
        }
      }
      return valido;
    },
    validarSerie: function validarSerie() {
      var valido = true;
      var valor = this.serie;
      this.limpiarError("serie");
      valido = this.validarVacio("serie", valor);
      if (valido) {
        if (!__WEBPACK_IMPORTED_MODULE_7__assets_js_validador__["a" /* default */].validarExpresion("serie", valor)) {
          this.guardarError("serie", "El número de serie/documento no es válido");
          valido = false;
        } else {
          this.form.cow = valor.replace(/\./g, "");
        }
      }
      return valido;
    },
    validarPassword: function validarPassword(campo, valor) {
      var valido = true;
      var mensaje = "Contraseña no válida: ";
      var errores = [];
      this.limpiarError(campo);
      valido = this.validarVacio(campo, valor);
      if (valido) {
        if (!__WEBPACK_IMPORTED_MODULE_7__assets_js_validador__["a" /* default */].validarExpresion("password", valor)) {
          errores.push("La contraseña debe tener mínimo 8 caracteres y debe contener al menos una letra mayúscula, una letra minúscula, un número y un símbolo. Ejemplo contraseña: Abcdef1#");
          this.guardarError("password", "Contraseña no válida: La contraseña debe tener mínimo 8 caracteres y debe contener al menos una letra mayúscula, una letra minúscula, un número y un símbolo. Ejemplo contraseña: Abcdef1#");
          valido = false;
        }
        if (valor.length < 8 ? errores.push("Debe tener más de 8 caracteres") : valido) ;
        if (errores.length > 0) {
          this.guardarError(campo, mensaje + errores[0]);
          valido = false;
        }
      }
      if (valido) {
        valido = this.validarConfirmacion("password", "password2", this.form.clave, this.password2, "Las contraseñas ingresadas no coinciden");
      } else {
        this.limpiarErroresMediosContacto();
      }
      return valido;
    },
    validarFechaNacimiento: function validarFechaNacimiento() {
      var valido = true;
      this.limpiarError("fecha");
      valido = this.validarFechaCompleta();
      if (valido) {
        if (!__WEBPACK_IMPORTED_MODULE_7__assets_js_validador__["a" /* default */].validarExpresion("fecha", this.form.fechaDeNacimiento)) {
          this.guardarError("fecha", "Fecha no válida");
        }
      }
      return valido;
    },
    validarChecboxes: function validarChecboxes() {
      var valido = true;
      if (!this.terminos) {
        this.guardarError("terminos", "Debes aceptar los términos y condiciones del proceso de admisión");
        valido = false;
      }
      if (!this.protocolo) {
        this.guardarError("protocolo", "Debes aceptar el protocolo de manejo de datos");
        valido = false;
      }
      if (!valido ? this.checboxError = true : this.checboxError = false) ;
      return valido;
    },
    validarMediosContacto: function validarMediosContacto() {
      this.modificado;
      var valido = true;
      var validoCorreo = true;
      var validoTelefono = true;
      var correo = this.form.correoElectronico.length <= 1;
      var telefono = this.form.telefonoMovil.length <= 1;
      if (correo) {
        this.guardarError("correo", "Debes ingresar un correo electrónico válido");
        this.guardarError("correo2", "");
        valido = false;
      } else {
        if (!correo) {
          validoCorreo = this.validarConfirmacion("correo", "correo2", this.form.correoElectronico, this.correo2, "Los correos ingresados no coinciden");
        }
        if (!telefono) {
          validoTelefono = this.validarConfirmacion("telefono", "telefono2", this.form.telefonoMovil, this.telefono2, "Los números telefónicos ingresados no coinciden");
        }
        valido = validoCorreo && validoTelefono;
      }
      return valido;
    },
    validarFechaCompleta: function validarFechaCompleta() {
      var valido = true;
      this.limpiarError("fecha");
      if (this.dia === null && this.mes === null && this.anio === null) {
        this.guardarError("fecha", "Campo Obligatorio");
        valido = false;
      } else if (this.dia === null || this.mes === null || this.anio === null) {
        this.guardarError("fecha", "Fecha Incompleta");
        valido = false;
      } else {
        this.form.fechaDeNacimiento = (this.dia < 10 ? "0" + this.dia : this.dia) + "/" + this.mes + "/" + this.anio;
      }
      return valido;
    },
    limpiarErroresMediosContacto: function limpiarErroresMediosContacto() {
      this.limpiarError("correo");
      this.limpiarError("telefono");
      this.limpiarError("correo2");
      this.limpiarError("telefono2");
      this.limpiarError("password");
    },
    validarConfirmacion: function validarConfirmacion(campo1, campo2, valor1, valor2, mensaje) {
      var valido = true;
      this.limpiarError(campo1);
      this.limpiarError(campo2);
      if (!(valor1 === valor2)) {
        this.guardarError(campo1, "");
        this.guardarError(campo2, mensaje);
        valido = false;
      }
      return valido;
    },
    listarAnios: function listarAnios() {
      var lista = [];
      var fecha = new Date();
      for (var anio = fecha.getFullYear() - 15; anio > fecha.getFullYear() - 90; anio--) {
        lista.push(anio);
      }
      return lista;
    },
    formatoRut: function formatoRut() {
      this.rut = __WEBPACK_IMPORTED_MODULE_5__assets_js_formatoRut__["a" /* default */].formateaRut(this.rut);
    },
    formatoSerie: function formatoSerie() {
      this.serie = __WEBPACK_IMPORTED_MODULE_5__assets_js_formatoRut__["a" /* default */].formatearSerie(this.serie);
    },
    validarFormulario: function validarFormulario() {
      this.$emit("cargar");
      this.modificado = ["run", "fecha", "serie", "correo", "correo2", "telefono", "telefono2", "password", "password2", "terminos", "protocolo"];
      var valido = [this.validarRut(), this.validarSerie(), this.validarPassword("password", this.form.clave), this.validarPassword("password2", this.password2), this.validarFechaNacimiento(), this.validarChecboxes(), this.validarMediosContacto()];
      var validado = true;
      if (valido.includes(false)) {
        validado = false;
      }
      this.$emit("cargado");
      return validado;
    },
    enviarFormulario: function enviarFormulario() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var reg;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.pendiente = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_8__services_ApiRegistro__["a" /* ApiRegistro */].registrarUsuario(_this2.form, _this2, _this2.config);

              case 3:
                reg = _context2.sent;

                if (reg) {
                  _this2.consultarEstado(reg);
                } else {
                  _this2.$emit("cargado");
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    consultarEstado: function consultarEstado(id) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var cuenta;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_8__services_ApiRegistro__["a" /* ApiRegistro */].consultarEstado(id, _this3);

              case 2:
                cuenta = _context3.sent;

                if (cuenta) {
                  setTimeout(function () {
                    _this3.informacionEstadoCuenta(cuenta.estado, id);
                  }, 2000);
                } else {
                  _this3.$emit("cargado");
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    informacionEstadoCuenta: function informacionEstadoCuenta(estado, id) {
      var _this4 = this;

      var message = "";
      switch (estado) {
        case "APROBADA":
          this.$refs.modalExitoso.showModal();
          this.$emit("cargado");
          break;
        case "RECHAZADA_FECHA_NACIMIENTO":
          message = "Los datos que has ingresado no concuerdan con nuestros registros.";
          this.$emit("cargado");
          this.$emit("onAlerta", message, "Datos Incorrectos");
          break;
        case "RECHAZADA_NO_POSTULANTES":
          this.$emit("cargado");
          this.$refs.modalApoderadoNoValido.showModal();
          break;
        case "RECHAZADA_COW":
          message = "Los datos que has ingresado no concuerdan con nuestros registros.";
          this.$emit("cargado");
          this.$emit("onError", message, "Datos incorrectos");
          break;
        case "COW_SIN_VALIDAR":
          this.$refs.modalExitoso.showModal();
          this.$emit("cargado");
          break;
        case "PENDIENTE":
          setTimeout(function () {
            _this4.consultarEstado(id);
          }, 2000);
          break;
      }
    }
  }
});

/***/ }),

/***/ "V861":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OlvidoContrasena_vue__ = __webpack_require__("e/p3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f740aadc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OlvidoContrasena_vue__ = __webpack_require__("kewg");
function injectStyle (ssrContext) {
  __webpack_require__("76OY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f740aadc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OlvidoContrasena_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f740aadc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OlvidoContrasena_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VdD7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvisibleRecaptcha_vue__ = __webpack_require__("lDFU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7adee8c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvisibleRecaptcha_vue__ = __webpack_require__("9WJ8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvisibleRecaptcha_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7adee8c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvisibleRecaptcha_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XOZF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('img',{staticClass:"img-fluid mt-1 mb-2 mt-lg-2",attrs:{"src":"https://admisionlogos.s3.amazonaws.com/registro-vue/cargador-logo-sistema-de-admision.png","alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Inicio__ = __webpack_require__("I0nj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Registro__ = __webpack_require__("b+8Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_OlvidoContrasena__ = __webpack_require__("V861");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_ClaveUnica__ = __webpack_require__("Zm76");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_ClaveUnicaError__ = __webpack_require__("2ROQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_UsuarioNoRegistrado__ = __webpack_require__("Q5tb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_RecuperarContrasena__ = __webpack_require__("38nF");










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  base: "/registro",
  mode: "history",
  routes: [{
    path: "/",
    name: "Inicio",
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Inicio__["a" /* default */]
  }, {
    path: "/registro",
    name: "Registro",
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Registro__["a" /* default */]
  }, {
    path: "/olvido-contrasena",
    name: "OlvidoContrasena",
    component: __WEBPACK_IMPORTED_MODULE_4__pages_OlvidoContrasena__["a" /* default */]
  }, {
    path: "/recuperar-contrasena/:id",
    name: "RecuperarContrasena",
    component: __WEBPACK_IMPORTED_MODULE_8__pages_RecuperarContrasena__["a" /* default */]
  }, {
    path: "/vitrina",
    name: "Vitrina",
    beforeEnter: function beforeEnter() {
      location.href = "https://admision.mineduc.cl/vitrina-vue";
    }
  }, {
    path: "/postulacion",
    name: "Postulacion",
    beforeEnter: function beforeEnter() {
      location.href = "https://admision.mineduc.cl/postulacion/";
    }
  }, {
    path: "/resultados",
    name: "Resultados",
    beforeEnter: function beforeEnter() {
      location.href = "https://admision.mineduc.cl/resultados/";
    }
  }, {
    path: "/ayuda-oficina-regional",
    name: "AyudaRegional",
    beforeEnter: function beforeEnter() {
      location.href = "https://www.ayudamineduc.cl/tema/54946#55265";
    }
  }, {
    path: "/postulacion-finalizada",
    name: "PostulacionFinalizada",
    beforeEnter: function beforeEnter() {
      location.href = "https://www.sistemadeadmisionescolar.cl/";
    }
  }, {
    path: "/clave-unica",
    name: "ClaveUnica",
    component: __WEBPACK_IMPORTED_MODULE_5__pages_ClaveUnica__["a" /* default */]
  }, {
    path: "/clave-unica-error",
    name: "ClaveUnicaError",
    component: __WEBPACK_IMPORTED_MODULE_6__pages_ClaveUnicaError__["a" /* default */]
  }, {
    path: "/usuario-no-registrado",
    name: "UsuarioNoRegistrado",
    component: __WEBPACK_IMPORTED_MODULE_7__pages_UsuarioNoRegistrado__["a" /* default */]
  }, {
    path: "*",
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Inicio__["a" /* default */]
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "YkU1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZZ9v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApiRegistro; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Errores__ = __webpack_require__("LQJy");



var _this = this;




var ApiRegistro = {
  registrarUsuario: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(registro, componente, gCaptchaToken) {
      var reg;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://apisae.mineduc.cl/sae-api-registro-persona/v1/public/" + "solicitud-cuenta", registro, gCaptchaToken).then(function (resp) {
                return resp.data;
              }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_3__utils_Errores__["a" /* default */].switchErrors(error, componente);
                return null;
              });

            case 2:
              reg = _context.sent;
              return _context.abrupt("return", reg);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function registrarUsuario(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(),
  consultarEstado: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(id, componente) {
      var cuenta;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://apisae.mineduc.cl/sae-api-registro-persona/v1/public/" + "solicitud-cuenta/" + id + "/estado").then(function (resp) {
                return resp.data;
              }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_3__utils_Errores__["a" /* default */].switchErrors(error, componente);
                return null;
              });

            case 2:
              cuenta = _context2.sent;
              return _context2.abrupt("return", cuenta);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function consultarEstado(_x4, _x5) {
      return _ref2.apply(this, arguments);
    };
  }()
};

/***/ }),

/***/ "Zm3I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/***/ }),

/***/ "Zm76":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClaveUnica_vue__ = __webpack_require__("GrQD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e23a6e22_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClaveUnica_vue__ = __webpack_require__("XOZF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClaveUnica_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e23a6e22_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClaveUnica_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a5iL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlechaArriba_vue__ = __webpack_require__("g9RN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75d9ae80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlechaArriba_vue__ = __webpack_require__("KeMu");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlechaArriba_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75d9ae80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlechaArriba_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b+8Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Registro_vue__ = __webpack_require__("UuG9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65360284_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Registro_vue__ = __webpack_require__("K+cs");
function injectStyle (ssrContext) {
  __webpack_require__("2gpL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65360284"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Registro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65360284_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Registro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b7Mv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-degrade"},[_c('b-container',{staticClass:"source-sans shadow mt-0 mt-md-3 mb-0 mb-md-4 mb-lg-5 px-0 px-lg-4 pt-2 pt-md-3 pb-4 bg-white"},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bAMU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c4fo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var formateaRut = function formateaRut(rut) {
  var actual = rut.replace(/^0+/, "");
  var rutPuntos = "";
  if (actual != "" && actual.length > 1) {
    var sinPuntos = actual.replace(/\./g, "");
    var actualLimpio = sinPuntos.replace(/-/g, "");
    var inicio = actualLimpio.substring(0, actualLimpio.length - 1);
    var j = 1;
    for (var i = inicio.length - 1; i >= 0; i--) {
      var letra = inicio.charAt(i);
      rutPuntos = letra + rutPuntos;
      if (j % 3 == 0 && j <= inicio.length - 1) {
        rutPuntos = "." + rutPuntos;
      }
      j++;
    }
    var dv = actualLimpio.substring(actualLimpio.length - 1);
    rutPuntos = rutPuntos + "-" + dv;
  } else {
    rutPuntos = rut;
  }
  return rutPuntos;
};

//Funcion para
var formatearSerie = function formatearSerie(serie) {
  var actual = serie.replace(/^0+/, "");
  var seriePuntos = "";
  if (actual != "" && actual.length > 1) {
    if (actual.charAt(0) === "A" || actual.charAt(0) === "a") {
      var sinPuntos = actual.replace(/\./g, "");
      seriePuntos = sinPuntos;
    } else {
      var _sinPuntos = actual.replace(/\./g, "");
      var actualLimpio = _sinPuntos.replace(/-/g, "");
      var inicio = actualLimpio;
      var j = 1;
      for (var i = inicio.length - 1; i >= 0; i--) {
        var letra = inicio.charAt(i);
        seriePuntos = letra + seriePuntos;
        if (j % 3 == 0 && j <= inicio.length - 1) {
          seriePuntos = "." + seriePuntos;
        }
        j++;
      }
    }
  } else {
    seriePuntos = serie;
  }
  return seriePuntos;
};

//funcion para validacion de digito verificador
var digitoVerificador = function digitoVerificador(run) {
  if (run) {
    var runSeparado = separarRun(run);
    var verificador = runSeparado.digitoVerificador;
    var cadena = runSeparado.run;
    var valor = 0;
    var serie = [2, 3, 4, 5, 6, 7];

    for (var i = 0; i < cadena.length; i++) {
      valor = valor + Number(cadena.charAt(cadena.length - (i + 1))) * serie[i % 6];
    }

    valor = 11 - valor % 11;

    if (valor === 10) {
      return (/^(k|K)$/.test(verificador)
      );
    } else if (valor === 11) {
      return verificador === "0";
    } else {
      return Number(verificador) === valor;
    }
  }
  return false;
};

//funcion separadora de Rut
var separarRun = function separarRun(string) {
  return {
    digitoVerificador: string.substr(string.length - 1),
    run: string.slice(0, -1).split(".").join("").replace("-", "")
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  formateaRut: formateaRut,
  digitoVerificador: digitoVerificador,
  formatearSerie: formatearSerie
});

/***/ }),

/***/ "ccNZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__ = __webpack_require__("C/JF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_free_solid_svg_icons__ = __webpack_require__("fhbW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__("1e6/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_1__fortawesome_free_solid_svg_icons__["j" /* faEnvelope */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["value", "estado", "placeholder", "mensajeError", "etiqueta", "prepend", "textInputgroup", "type", "maxlength", "dataTesting", "icono"],
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__["a" /* FontAwesomeIcon */]
  },
  methods: {
    handler: function handler(evento) {
      this.$emit("input", evento.target.value);
    },
    change: function change(evento) {
      this.$emit("change", evento);
    },
    blur: function blur(evento) {
      this.$emit("blur", evento);
    },
    keyup: function keyup(evento) {
      this.$emit("keyup", evento);
    }
  }
});

/***/ }),

/***/ "e/p3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generales_Volver__ = __webpack_require__("hP5U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generales_TituloRecuperarContrasena__ = __webpack_require__("ksXs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generales_inputs_InputWrapperSerie__ = __webpack_require__("Fk90");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_js_manejoErrores__ = __webpack_require__("xdtW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_js_validador__ = __webpack_require__("J7t/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_generales_recaptcha_InvisibleRecaptcha__ = __webpack_require__("VdD7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_js_formatoRut__ = __webpack_require__("c4fo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_svg_core__ = __webpack_require__("C/JF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fortawesome_free_solid_svg_icons__ = __webpack_require__("fhbW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fortawesome_vue_fontawesome__ = __webpack_require__("1e6/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_ApiLogin__ = __webpack_require__("jxoT");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












__WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_10__fortawesome_free_solid_svg_icons__["j" /* faEnvelope */]);
__WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_10__fortawesome_free_solid_svg_icons__["k" /* faSms */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__assets_js_manejoErrores__["a" /* manejoErrores */]],
  components: {
    Volver: __WEBPACK_IMPORTED_MODULE_2__components_generales_Volver__["a" /* default */],
    Titulo: __WEBPACK_IMPORTED_MODULE_3__components_generales_TituloRecuperarContrasena__["a" /* default */],
    InputWrapperSerie: __WEBPACK_IMPORTED_MODULE_4__components_generales_inputs_InputWrapperSerie__["a" /* default */],
    InvisibleRecaptcha: __WEBPACK_IMPORTED_MODULE_7__components_generales_recaptcha_InvisibleRecaptcha__["a" /* default */],
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_11__fortawesome_vue_fontawesome__["a" /* FontAwesomeIcon */]
  },
  data: function data() {
    return {
      usuario: {
        run: "",
        cow: "",
        medioContacto: "CORREO_ELECTRONICO"
      },
      config: {
        headers: {},
        params: {}
      },
      serie: "",
      rut: "",
      siteKey: "6LfE9rYqAAAAACUgAep0DVg4Nzpk4DQmnq1VlEy-",
      captchaHabilitado: localStorage.getItem("recatpchaHabilitado") || "true",
      modoRecuperarPassword: ""
    };
  },
  created: function created() {
    var obtenerValorLocalStorage = function obtenerValorLocalStorage(key) {
      var valorPorDefecto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "----";

      var valor = localStorage.getItem(key);
      return valor ? valor : valorPorDefecto;
    };
    this.modoRecuperarPassword = obtenerValorLocalStorage("modoRecuperarPassword");
    if (parseInt(this.modoRecuperarPassword) === 1) {
      this.usuario.medioContacto = "TELEFONO_MOVIL";
    }
  },

  methods: {
    //ELIMINAR ANTES DE PRODUCCION
    pruebaAutomatizada: function pruebaAutomatizada() {
      var formValido = this.validarFormulario();
      if (formValido) {
        this.config.headers = {
          "g-recaptcha-response": "recaptchaToken"
        };
        this.config.params = {
          tipoCaptcha: "INVISIBLE"
        };
        this.enviarFormulario();
      }
    },

    //ELIMINAR ANTES DE PRODUCCION
    captcha: function captcha(recaptchaToken) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!recaptchaToken) {
                  _context.next = 5;
                  break;
                }

                _this.config.headers = {
                  "g-recaptcha-response": recaptchaToken
                };
                _this.config.params = {
                  tipoCaptcha: "INVISIBLE"
                };
                _context.next = 5;
                return _this.enviarFormulario();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    formatoRut: function formatoRut() {
      this.rut = __WEBPACK_IMPORTED_MODULE_8__assets_js_formatoRut__["a" /* default */].formateaRut(this.rut);
    },
    formatoSerie: function formatoSerie() {
      this.serie = __WEBPACK_IMPORTED_MODULE_8__assets_js_formatoRut__["a" /* default */].formatearSerie(this.serie);
    },
    validarRut: function validarRut() {
      var valido = true;
      var valor = this.rut;
      var campo = "rut";
      this.limpiarError(campo);
      this.errorRut = false;
      if (valor.length < 1) {
        this.guardarError(campo, "El RUN ingresado no es válido");
        valido = false;
      } else if (!__WEBPACK_IMPORTED_MODULE_6__assets_js_validador__["a" /* default */].validarExpresion("rut", valor) || !__WEBPACK_IMPORTED_MODULE_8__assets_js_formatoRut__["a" /* default */].digitoVerificador(valor)) {
        this.guardarError(campo, "El Run no es válido");
        valido = false;
      }
      if (valido) {
        this.usuario.run = parseInt(valor.slice(0, -1).split(".").join("").replace("-", ""));
      } else {
        this.errorRut = true;
      }
      return valido;
    },
    validarSerie: function validarSerie() {
      var valido = true;
      var valor = this.serie;
      var campo = "serie";
      this.limpiarError(campo);

      if (valor.length < 1) {
        this.guardarError(campo, "El número de serie/documento es un campo obligatorio");
        valido = false;
      } else if (!__WEBPACK_IMPORTED_MODULE_6__assets_js_validador__["a" /* default */].validarExpresion("serie", valor)) {
        this.guardarError(campo, "El número de serie/documento no es válido");
        valido = false;
      } else {
        this.usuario.cow = valor.replace(/\./g, "");
      }
      return valido;
    },
    validarFormulario: function validarFormulario() {
      this.$emit("cargar");
      var valido = true;
      this.modificado = ["rut", "serie", "contacto"];
      var validado = [this.validarRut(), this.validarSerie()];
      if (validado.includes(false)) {
        valido = false;
        this.$emit("cargado");
      }
      return valido;
    },
    enviarFormulario: function enviarFormulario() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var solicitudCambioClave;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_12__services_ApiLogin__["a" /* default */].solicitudCambioClave(_this2.usuario, _this2, _this2.config);

              case 2:
                solicitudCambioClave = _context2.sent;

                if (!solicitudCambioClave) {
                  _context2.next = 8;
                  break;
                }

                _this2.$router.push({
                  name: "RecuperarContrasena",
                  params: {
                    id: solicitudCambioClave.id,
                    medio: solicitudCambioClave.medio
                  }
                });
                return _context2.abrupt("return", true);

              case 8:
                _this2.$emit("cargado");
                return _context2.abrupt("return", false);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),

/***/ "ezNm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformacionPostulacion_vue__ = __webpack_require__("uI1Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82b2b56a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformacionPostulacion_vue__ = __webpack_require__("Ca6f");
function injectStyle (ssrContext) {
  __webpack_require__("BsyW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-82b2b56a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformacionPostulacion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82b2b56a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformacionPostulacion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f8rH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fYu+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"my-modal",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","body-class":"text-azul py-5 text-center bg-azul-claro","header-class":"border-0 pb-0","footer-class":"justify-content-center gilmer","centered":"","scrollable":""}},[_c('div',{attrs:{"slot":"modal-title"},slot:"modal-title"},[_c('h5',{staticClass:"gilmer text-uppercase font-weight-bold text-azul-medio h6"})]),_vm._v(" "),_c('div',{staticClass:"text-azul font-weight-bold gilmer h5"},[(_vm.tipoModal === 'EXITO')?_c('font-awesome-icon',{staticClass:"text-azul mt-4 mr-2 text-success",attrs:{"icon":"check"}}):(_vm.tipoModal === 'ALERTA')?_c('font-awesome-icon',{staticClass:"text-azul mt-4 mr-2 text-danger",attrs:{"icon":"exclamation-triangle"}}):(_vm.tipoModal === 'ERROR')?_c('font-awesome-icon',{staticClass:"text-azul mt-4 mr-2 text-danger",attrs:{"icon":"exclamation-triangle"}}):_vm._e(),_vm._v("\n    "+_vm._s(_vm.tituloModalPersonalizado)+"\n  ")],1),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.mensaje)}}),_vm._v(" "),(_vm.ayudaMieduc)?_c('p',[_vm._v("\n    Para más información o solución de problemas dirígete a una oficina de\n    "),_c('router-link',{attrs:{"data-testid":"enlace-redireccion-ayuda","to":{ name: 'AyudaRegional' }}},[_vm._v("\n      Ayuda Mineduc.\n    ")])],1):_vm._e(),_vm._v(" "),(_vm.botoneraDoble)?_c('div',{staticClass:"justify-content-center gilmer",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('router-link',{staticClass:"btn btn-gris-outline px-4 col-12 col-lg-auto mx-0 mx-lg-auto",attrs:{"tag":"button","data-testid":"modal-enlace-redireccion-1","to":{ name: 'Inicio' }}},[_vm._v("\n      Iniciar sesión\n    ")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-gris-outline px-4 col-12 col-lg-auto mx-0 mx-lg-auto",attrs:{"tag":"button","data-testid":"modal-enlace-redireccion-2","to":{ name: 'OlvidoContrasena' }}},[_vm._v("\n      Recuperar contraseña\n    ")])],1):(_vm.recuperarContrasenia)?_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('router-link',{staticClass:"btn btn-azul-oscuro2 px-4 font-weight-bold",attrs:{"tag":"button","data-testid":"modal-boton-ok","to":{ name: 'Inicio' }}},[_vm._v("\n      "+_vm._s(_vm.textoBoton ? _vm.textoBoton : "Ir a la página de inicio")+"\n    ")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-azul-oscuro2 px-4 font-weight-bold",attrs:{"tag":"button","data-testid":"modal-enlace-redireccion-2","to":{ name: 'OlvidoContrasena' }}},[_vm._v("\n      Recuperar contraseña\n    ")])],1):_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[(_vm.destino)?_c('router-link',{staticClass:"btn btn-azul-oscuro2 px-4",attrs:{"tag":"button","data-testid":"modal-enlace-redireccion-2","to":{ name: _vm.destino }}},[_vm._v("\n      "+_vm._s(_vm.textoBoton ? _vm.textoBoton : "Aceptar")+"\n    ")]):_c('button',{staticClass:"btn btn-azul-oscuro2 px-4",attrs:{"data-testid":"modal-boton-ok"},on:{"click":_vm.hideModal}},[_vm._v("\n      "+_vm._s(_vm.textoBoton ? _vm.textoBoton : "OK")+"\n    ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fwmn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{class:(_vm.negrita === 'true' ? 'font-weight-bold ' : '') + 'mb-1 w-100'},[_vm._v(_vm._s(_vm.etiqueta))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('b-form-input',{class:(_vm.grande === 'true' ? 'form-control-lg ' : '') + 'redondo-derecho',attrs:{"type":_vm.tipoInput,"data-testid":_vm.dataTestid,"maxlength":_vm.maxlength,"state":_vm.estado,"trim":"","autocomplete":"off"},on:{"blur":_vm.blur,"keyup":_vm.keyup},nativeOn:{"change":function($event){return _vm.change.apply(null, arguments)},"input":function($event){return _vm.handler.apply(null, arguments)}}}),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-stretch pl-1"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn-azul-outline h-100 d-flex align-items-center",attrs:{"data-testid":'button-' + _vm.dataTestid,"title":"Mostrar / Ocultar Contraseña","variant":"outline-light"},on:{"click":function($event){return _vm.mostrarcontrasena()}}},[_c('font-awesome-icon',{staticClass:"m-0",attrs:{"icon":_vm.icono}})],1)],1),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.mensajeError))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g9RN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__ = __webpack_require__("C/JF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_free_solid_svg_icons__ = __webpack_require__("fhbW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__("1e6/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_1__fortawesome_free_solid_svg_icons__["a" /* faAngleUp */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__["a" /* FontAwesomeIcon */]
  },
  data: function data() {
    return {
      mueve: false,
      arriba: false
    };
  },

  mounted: function mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed: function destroyed() {
    this.eliminarListenerFlechaAbajo();
  },
  methods: {
    //mueve pagina a parte superior
    scrollToTop: function scrollToTop() {
      window.scrollTo(0, 0);
    },
    handleScroll: function handleScroll(e) {
      this.mueve = true;
      if (Math.round(window.pageXOffset) != 0 || Math.round(window.pageYOffset) != 0) {
        this.arriba = true;
      } else {
        this.arriba = false;
      }
    },
    eliminarListenerFlechaAbajo: function eliminarListenerFlechaAbajo() {
      window.removeEventListener("scroll", this.handleScroll);
    }
  }
});

/***/ }),

/***/ "gV00":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformacionRegistro_vue__ = __webpack_require__("oKpQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2decfede_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformacionRegistro_vue__ = __webpack_require__("I23l");
function injectStyle (ssrContext) {
  __webpack_require__("3HKp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2decfede"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformacionRegistro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2decfede_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformacionRegistro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "glzv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column vh-100",attrs:{"id":"app","data-spy":"scroll"}},[_c('Flecha'),_vm._v(" "),_c('Header'),_vm._v(" "),_c('Section',[_c('router-view',{on:{"cargar":_vm.cargar,"cargado":_vm.cargado,"onError":_vm.atraparError,"onAlerta":_vm.atraparAlerta}})],1),_vm._v(" "),_c('Footer'),_vm._v(" "),_c('b-modal',{attrs:{"id":"modalCargando-1","centered":"","no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-footer":"","hide-header":"","size":"sm"},model:{value:(_vm.modalCargando),callback:function ($$v) {_vm.modalCargando=$$v},expression:"modalCargando"}},[_c('Cargando',{attrs:{"color":"#000000","tamanio":200}})],1),_vm._v(" "),_c('Modal',{ref:"modalError",attrs:{"tipoModal":"ERROR","mensaje":_vm.mensajeError,"tituloMensaje":_vm.tituloError,"ayudaMineduc":_vm.ayudaMineduc,"recuperarContrasenia":_vm.recuperarContrasenia,"destino":_vm.destino}}),_vm._v(" "),_c('Modal',{ref:"modalAlerta",attrs:{"tipoModal":"ALERTA","mensaje":_vm.mensajeError,"tituloMensaje":_vm.tituloError,"botoneraDoble":_vm.botoneraDoble,"ayudaMineduc":_vm.ayudaMineduc,"recuperarContrasenia":_vm.recuperarContrasenia,"destino":_vm.destino}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hP5U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Volver_vue__ = __webpack_require__("iVw3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce36f0ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Volver_vue__ = __webpack_require__("oEsa");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Volver_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce36f0ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Volver_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iVw3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__ = __webpack_require__("C/JF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_free_solid_svg_icons__ = __webpack_require__("fhbW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__("1e6/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_1__fortawesome_free_solid_svg_icons__["i" /* faArrowLeft */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["redireccion"],
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__["a" /* FontAwesomeIcon */]
  }
});

/***/ }),

/***/ "j7uu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j82G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"h6 text-center rounded text-white px-0 bg-azul-medio w-100 mb-5 pb-2"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"gilmer text-uppercase h5 pt-3 font-weight-bold"},[_vm._v("\n        ¿Aún no tienes cuenta?\n      ")]),_vm._v(" "),_c('p',{staticClass:"m-3 text-justify h5",attrs:{"for":"run"}},[_vm._v("\n        Regístrate para crear tu usuario como apoderado, así estarás listo\n        para postular cuando se inicie el proceso. Si ya te registraste en\n        años anteriores, o ya cuentas con un IPA no es necesario que lo\n        vuelvas a realizar.\n      ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-azul-outline text-uppercase gilmer my-3 font-weight-bold px-4",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$router.push({ name: 'Registro' })}}},[_vm._v("REGISTRARME")])])]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h6 text-justify rounded text-white px-0 bg-azul-medio w-100 mt-5 px-2 py-4"},[_c('p',{staticClass:"m-3 h5"},[_vm._v("\n      Si eres ciudadano extranjero y no cuentas con RUN chileno, obtén tu\n      Identificador Provisorio del Estudiante (IPE) o tu Identificador\n      Provisorio del Apoderado (IPA) para poder postular.\n    ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('a',{staticClass:"btn btn-azul-outline text-uppercase gilmer my-3 font-weight-bold px-4 mx-auto",attrs:{"href":"https://ayudamineduc.cl/tramites-en-linea","target":"_blank"}},[_vm._v("Obtener IPE e IPA")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jd3S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformacionAceptaCondiciones_vue__ = __webpack_require__("OgR5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5c19cec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformacionAceptaCondiciones_vue__ = __webpack_require__("HK7E");
function injectStyle (ssrContext) {
  __webpack_require__("CI4P")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d5c19cec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformacionAceptaCondiciones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5c19cec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformacionAceptaCondiciones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jxoT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Errores__ = __webpack_require__("LQJy");



var _this = this;



var loguearUsuario = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(credenciales, componente, gCaptchaToken) {
    var login;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://apisae.mineduc.cl/sae-api-registro-persona/v1/public/" + "cuenta/login", credenciales, gCaptchaToken).then(function (resp) {
              return resp.data;
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_3__utils_Errores__["a" /* default */].switchErrors(error, componente, [{
                codigo: 503,
                mensaje: "El periodo de postulación ha finalizado. Infórmate sobre las próximas etapas en <a href='https://www.sistemadeadmisionescolar.cl'>www.sistemadeadmisionescolar.cl</a>"
              }]);
              return null;
            });

          case 2:
            login = _context.sent;
            return _context.abrupt("return", login);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function loguearUsuario(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var solicitudCambioClave = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(usuario, componente, gCaptchaToken) {
    var solicitud;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://apisae.mineduc.cl/sae-api-registro-persona/v1/public/" + "solicitud-cambio-clave", usuario, gCaptchaToken).then(function (resp) {
              return resp.data;
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_3__utils_Errores__["a" /* default */].switchErrors(error, componente);
              return null;
            });

          case 2:
            solicitud = _context2.sent;
            return _context2.abrupt("return", solicitud);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function solicitudCambioClave(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

var cambiarClave = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(datos, componente) {
    var solicitud;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put("https://apisae.mineduc.cl/sae-api-registro-persona/v1/public/" + "cuenta/cambio-clave", datos).then(function (resp) {
              return true;
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_3__utils_Errores__["a" /* default */].switchErrors(error, componente);
              return false;
            });

          case 2:
            solicitud = _context3.sent;
            return _context3.abrupt("return", solicitud);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function cambiarClave(_x7, _x8) {
    return _ref3.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  loguearUsuario: loguearUsuario,
  solicitudCambioClave: solicitudCambioClave,
  cambiarClave: cambiarClave
});

/***/ }),

/***/ "kewg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-azul-claro",attrs:{"id":"olvido-contrasena"}},[_c('Volver',{attrs:{"redireccion":"Inicio"}}),_vm._v(" "),_c('Titulo',{attrs:{"subtitulo":"Ingresa los datos solicitados a continuación"}},[_c('b-col',{staticClass:"mt-3",attrs:{"cols":"12","md":"6"}},[_c('label',{staticClass:"mb-1 font-weight-bold"},[_vm._v("RUN apoderado")]),_vm._v(" "),_c('b-input',{staticClass:"form-control form-control-lg placeholder borde-amarillo",attrs:{"data-testid":"form-run","type":"text","id":"form_rut","placeholder":"21.123.456-1","maxlength":"12","state":this.tieneError('rut'),"autocomplete":"off"},on:{"~keyup":function($event){return _vm.modificado.push('rut')},"change":_vm.validarRut,"keyup":_vm.formatoRut},model:{value:(_vm.rut),callback:function ($$v) {_vm.rut=$$v},expression:"rut"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n        "+_vm._s(this.mensajeError("rut"))+"\n      ")])],1),_vm._v(" "),_c('b-col',{staticClass:"mt-3",attrs:{"cols":"12","md":"6"}},[_c('InputWrapperSerie',{attrs:{"negrita":"true","grande":"true","state":this.tieneError('serie'),"mensajeError":this.mensajeError('serie')},on:{"~keyup":function($event){return _vm.modificado.push('serie')},"keyup":_vm.formatoSerie,"change":_vm.validarSerie},model:{value:(_vm.serie),callback:function ($$v) {_vm.serie=$$v},expression:"serie"}})],1),_vm._v(" "),_c('div',{staticClass:"mt-3 mt-lg-4 mb-2 font-weight-bold mx-auto text-center"},[_vm._v("\n      *Recuerda que si postulaste con IPA (200.123.456-7), solo podrás\n      reestablecer tu contraseña llamando al 600 600 26 26 o directamente en\n      las oficinas de atención ciudadana de Ayuda Mineduc.\n    ")]),_vm._v(" "),_c('b-row',{staticClass:"bg-azul-claro py-3 py-lg-4 px-2 px-lg-5 text-center mx-2 w-100 justify-align-center text-center"},[(
          parseInt(_vm.modoRecuperarPassword) === 0 ||
            parseInt(_vm.modoRecuperarPassword) === 2
        )?_c('b-col',{staticClass:"ml-0 ml-lg-auto pl-2 pr-lg-5 mx-auto text-center",attrs:{"cols":"12","lg":"auto"}},[_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"d-flex align-items-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario.medioContacto),expression:"usuario.medioContacto"}],attrs:{"data-testid":"form-radio-correo","type":"radio","name":"radio","value":"CORREO_ELECTRONICO"},domProps:{"checked":_vm._q(_vm.usuario.medioContacto,"CORREO_ELECTRONICO")},on:{"change":function($event){return _vm.$set(_vm.usuario, "medioContacto", "CORREO_ELECTRONICO")}}}),_vm._v(" "),_c('span',{staticClass:"label-text"},[_vm._v("Correo electrónico")]),_vm._v(" "),_c('font-awesome-icon',{staticClass:"fa-3x ml-auto ml-lg-3 text-azul-claro",attrs:{"icon":"envelope"}})],1)])]):_vm._e(),_vm._v(" "),(
          parseInt(_vm.modoRecuperarPassword) === 1 ||
            parseInt(_vm.modoRecuperarPassword) === 2
        )?_c('b-col',{staticClass:"ml-0 ml-lg-auto pl-2 pl-lg-auto pr-auto pr-lg-5 mx-auto text-center",attrs:{"cols":"12","lg":"auto"}},[_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"d-flex align-items-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario.medioContacto),expression:"usuario.medioContacto"}],attrs:{"data-testid":"form-radio-telefono","type":"radio","name":"radio","value":"TELEFONO_MOVIL"},domProps:{"checked":_vm._q(_vm.usuario.medioContacto,"TELEFONO_MOVIL")},on:{"change":function($event){return _vm.$set(_vm.usuario, "medioContacto", "TELEFONO_MOVIL")}}}),_vm._v(" "),_c('span',{staticClass:"label-text"},[_vm._v("Teléfono móvil")]),_vm._v(" "),_c('font-awesome-icon',{staticClass:"fa-3x ml-auto ml-lg-3 text-azul-claro",attrs:{"icon":"sms"}})],1)])]):_vm._e()],1),_vm._v(" "),_c('b-col',{staticClass:"mb-2 mt-3 mt-lg-5 px-0 px-lg-3 text-center mb-5",attrs:{"cols":"12"}},[(_vm.captchaHabilitado)?_c('InvisibleRecaptcha',{staticClass:"btn btn-lg btn-azul-oscuro2 gilmer text-left pr-3 mt-2 px-4 font-weight-bold",attrs:{"data-test":"button-recuperar","id":"enviar-form-captcha","sitekey":_vm.siteKey,"validate":_vm.validarFormulario,"callback":_vm.captcha,"theme":"light","disabled":false,"type":"submit"}},[_vm._v("Recuperar Contraseña")]):_vm._e(),_vm._v(" "),(!_vm.captchaHabilitado)?_c('button',{staticClass:"btn btn-lg btn-azul-oscuro2 gilmer text-left pr-3 mt-2 px-4 font-weight-bold",attrs:{"data-test":"button-recuperar","id":"enviar-form"},on:{"click":function($event){$event.preventDefault();return _vm.pruebaAutomatizada.apply(null, arguments)}}},[_vm._v("\n        Recuperar Contraseña\n      ")]):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ksXs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TituloRecuperarContrasena_vue__ = __webpack_require__("m3GG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d85bd24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TituloRecuperarContrasena_vue__ = __webpack_require__("Jqxn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TituloRecuperarContrasena_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d85bd24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TituloRecuperarContrasena_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lDFU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_EventBus__ = __webpack_require__("Zm3I");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dataTest: {
      type: String,
      required: true
    },
    sitekey: {
      type: String,
      required: true
    },
    badge: {
      type: String,
      required: false,
      default: "bottomleft"
    },
    theme: {
      type: String,
      required: false,
      default: "dark"
    },
    validate: {
      type: Function,
      required: false
    },
    callback: {
      type: Function,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    id: {
      type: String,
      required: false
    },

    reference: {
      type: String,
      required: false
    },

    type: {
      type: String,
      required: false,
      default: "submit"
    }
  },
  data: function data() {
    return {
      widgetId: false,
      loaded: false
    };
  },
  methods: {
    render: function render() {
      var _this = this;

      if (typeof grecaptcha !== "undefined") {
        /*&& grecaptcha.render) {*/
        this.widgetId = grecaptcha.enterprise.ready(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
          var token;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return grecaptcha.enterprise.execute(_this.sitekey, {
                    action: "LOGIN"
                  });

                case 2:
                  token = _context.sent;

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this);
        })));
        /*this.widgetId = grecaptcha.render(this.recaptchaId, {
          sitekey: this.sitekey,
          size: "invisible",
          badge: this.badge,
          theme: this.theme,
          callback: token => {
            this.callback(token);
            grecaptcha.reset(this.widgetId);
          }
        });
        */
        this.loaded = true;
      } else {
        this.renderWait();
      }
    },
    renderWait: function renderWait() {
      var self = this;
      setTimeout(function () {
        if (typeof grecaptcha !== "undefined" && grecaptcha.render) {
          self.render();
        } else {
          self.renderWait();
        }
      }, 100);
    },
    click: function click() {
      var _this2 = this;

      if (!this.validate || this.validate && this.validate() !== false)
        /*grecaptcha.execute();*/
        grecaptcha.enterprise.ready(function () {
          grecaptcha.enterprise.execute(_this2.sitekey, {
            action: "LOGIN"
          }).then(function (token) {
            _this2.callback(token);
          }).catch(function () {
            console.log("ERROR validate captcha:");
            /** invalid reCaptcha score */
          });
        });
    }
  },
  computed: {
    computedClass: function computedClass() {
      var classArray = this.class ? this.class.split(" ") : [];
      if (this.value) {
        classArray.push("invisible-recaptcha");
      }
      return classArray;
    },
    recaptchaId: function recaptchaId() {
      return "vue-invisible-recaptcha-" + this._uid;
    }
  },
  mounted: function mounted() {
    if (typeof grecaptcha === "undefined") {
      var script = document.createElement("script");
      script.src = "https://www.google.com/recaptcha/enterprise.js?render=" + this.sitekey;
      script.onload = this.renderWait;
      document.head.appendChild(script);
    } else {
      this.render();
    }
  }
});

/***/ }),

/***/ "m3GG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["subtitulo"]
});

/***/ }),

/***/ "mSax":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cargando_vue__ = __webpack_require__("+LT/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5d00b6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cargando_vue__ = __webpack_require__("4yu6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cargando_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5d00b6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cargando_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "o4SK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"m-0 pt-1 mx-auto"},[_c('div',{class:_vm.tamanioTitulo + _vm.claseTituo},[_vm._v(_vm._s(_vm.titulo))])]),_vm._v(" "),_c('b-col',{staticClass:"text-azul text-center text-lg-center px-4 border-bottom pb-2 border-azul-claro2 border-2 gilmer mx-auto",attrs:{"cols":"12","lg":"10"}},[_c('span',{staticClass:"subtitulo-cursiva",domProps:{"innerHTML":_vm._s(_vm.subtitulo)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oEsa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"m-0 pt-1"},[_c('b-col',{staticClass:"ml-0 ml-lg-auto text-right pl-3 pr-3 pr-md-3 pr-lg-0 d-flex align-items-center",attrs:{"cols":"auto"}},[_c('router-link',{staticClass:"text-azul gilmer font-weight-light mb-0",attrs:{"data-testid":"button-volver","to":{ name: _vm.redireccion }}},[_c('font-awesome-icon',{staticClass:"h5 mb-0",attrs:{"icon":"arrow-left"}}),_vm._v(" "),_c('span',{staticClass:"ml-2"},[_vm._v("Volver   ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oKpQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "InformacionRegistro",
  data: function data() {
    return {
      ayuda: "https://www.ayudamineduc.cl/ficha/postulacion-al-sistema-de-admision-escolar",
      anioPostulacion: "",
      anioAdmision: "",
      inicioPostulacion: "",
      finPostulacion: ""
    };
  },
  created: function created() {
    var obtenerValorLocalStorage = function obtenerValorLocalStorage(key) {
      var valorPorDefecto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "----";

      var valor = localStorage.getItem(key);
      return valor ? valor : valorPorDefecto;
    };

    this.anioPostulacion = obtenerValorLocalStorage("anioPostulacion");
    this.anioAdmision = obtenerValorLocalStorage("anioAdmision");
    this.inicioPostulacion = obtenerValorLocalStorage("inicioPostulacion");
    this.finPostulacion = obtenerValorLocalStorage("finPostulacion");
  }
});

/***/ }),

/***/ "p4Vt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md order-1 order-md-0"},[_c('div',{staticClass:"text-azul-medio text-uppercase gilmer h4 text-center mt-5 mt-md-3 font-weight-light"},[_vm._v("\n    Acerca del proceso\n  ")]),_vm._v(" "),_c('div',{staticClass:"bg-azul-claro py-4 px-4 h6 text-center rounded"},[_vm._v("\n    Los\n    "),_c('strong',[_vm._v("resultados finales")]),_vm._v(" del Sistema de Admisión Escolar están\n    disponibles en este portal a partir del\n    "),_c('strong',[_vm._v(_vm._s(_vm.fechaResultadosFinales))]),_vm._v(" "),_c('img',{staticClass:"img-fluid my-4",attrs:{"src":"https://cdnsaemineduc.s3.us-east-1.amazonaws.com/img/imagen_calendario_resultados_complementario.svg","width":"280","alt":""}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"bg-azul-claro py-3 px-4 h6 text-center rounded mt-5 mt-lg-3"},[_c('a',{staticClass:"gilmer h5 font-weight-light",attrs:{"href":_vm.ayuda,"data-testid":"enlace-ayuda-mineduc","target":"_blank"}},[_c('strong',{staticClass:"d-inline-block"},[_vm._v("¿Dudas con tus resultados?")]),_vm._v(" "),_c('span',{staticClass:"d-inline-block mt-2 text-uppercase font-weight-bold subrayado h6"},[_vm._v("Consulta Ayuda Mineduc")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-azul-medio rounded py-4 text-white gilmer mx-0 mx-lg-3"},[_vm._v("\n      Accede con el mismo\n      "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("USUARIO")]),_vm._v(" y\n      "),_c('strong',[_vm._v("CONTRASEÑA")]),_vm._v(" "),_c('br'),_vm._v("del proceso de postulación\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pKYy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "psb7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{class:_vm.negrita == 'true' ? 'mb-1 w-100 font-weight-bold' : 'mb-1 w-100',attrs:{"for":"numserie"}},[_vm._v("Número de serie/documento")]),_vm._v(" "),_c('b-input-group',{staticClass:"borde-amarillo"},[_c('b-col',{staticClass:"p-0"},[_c('b-form-input',{staticClass:"placeholder boton-prepend",class:_vm.grande == 'true' ? 'form-control-lg' : '',attrs:{"data-testid":"form-cow","type":"text","placeholder":"A012345678/123.456.789","state":_vm.state,"maxlength":"11","value":_vm.value,"autocomplete":"off"},on:{"blur":_vm.blur,"keyup":_vm.keyup},nativeOn:{"change":function($event){return _vm.change.apply(null, arguments)},"input":function($event){return _vm.handler.apply(null, arguments)}}})],1),_vm._v(" "),_c('b-col',{staticClass:"p-0",attrs:{"cols":"auto"}},[_c('b-input-group-text',{staticClass:"bg-white boton-append h-100 d-flex",attrs:{"slot":"append","id":"popovercarnet1"},slot:"append"},[_c('a',{staticClass:"text-secondary"},[_c('font-awesome-icon',{staticClass:"m-0",attrs:{"icon":"info"}})],1),_vm._v(" "),_c('b-popover',{attrs:{"target":"popovercarnet1","placement":"left","triggers":"hover focus","data-testid":"form-popover"}},[_c('h6',{staticClass:"text-center"},[_vm._v("\n            ¿Dónde consigo el número de serie/documento?\n          ")]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":"https://cdnsaemineduc.s3.us-east-1.amazonaws.com/img/numero-documento.png"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":"https://cdnsaemineduc.s3.us-east-1.amazonaws.com/img/serie.png"}})])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"mensaje-error"},[_vm._v(_vm._s(_vm.mensajeError))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qb6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uI1Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_login_InformacionAceptaCondiciones__ = __webpack_require__("jd3S");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    InformacionAceptaCondiciones: __WEBPACK_IMPORTED_MODULE_0__components_login_InformacionAceptaCondiciones__["a" /* default */]
  },
  name: "InformacionPostulacion",
  data: function data() {
    return {
      ayuda: "https://www.ayudamineduc.cl/ficha/postulacion-al-sistema-de-admision-escolar",
      anioPostulacion: "",
      anioAdmision: ""
    };
  },
  created: function created() {
    var obtenerValorLocalStorage = function obtenerValorLocalStorage(key) {
      var valorPorDefecto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "----";

      var valor = localStorage.getItem(key);
      return valor ? valor : valorPorDefecto;
    };

    this.anioPostulacion = obtenerValorLocalStorage("anioPostulacion");
    this.anioAdmision = obtenerValorLocalStorage("anioAdmision");
    this.inicioPostulacion = obtenerValorLocalStorage("inicioPostulacion");
    this.finPostulacion = obtenerValorLocalStorage("finPostulacion");
  }
});

/***/ }),

/***/ "vCYt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fc2cf6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Section_vue__ = __webpack_require__("b7Mv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fc2cf6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Section_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wHr2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wpXN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"role":"group"}},[_c('label',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.etiqueta))]),_vm._v(" "),_c('b-input-group',[(_vm.prepend === 'true')?_c('b-input-group-text',{staticClass:"bg-white",attrs:{"slot":"prepend"},slot:"prepend"},[(_vm.icono)?_c('font-awesome-icon',{attrs:{"icon":"envelope"}}):_vm._e(),_vm._v("\n      "+_vm._s(_vm.textInputgroup ? _vm.textInputgroup : ""))],1):_vm._e(),_vm._v(" "),_c('b-form-input',{class:'rounded placeholder',attrs:{"data-testid":_vm.dataTesting,"maxlength":_vm.maxlength,"type":_vm.type ? _vm.type : 'text',"state":_vm.estado,"value":_vm.value,"placeholder":_vm.placeholder,"trim":"","autocomplete":"off"},on:{"blur":_vm.blur,"keyup":_vm.keyup},nativeOn:{"change":function($event){return _vm.change.apply(null, arguments)},"input":function($event){return _vm.handler.apply(null, arguments)}}})],1),_vm._v(" "),_c('b-form-invalid-feedback',{staticClass:"d-block mt-1"},[_vm._v(_vm._s(_vm.mensajeError))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xEUv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputTextWrapper_vue__ = __webpack_require__("ccNZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_268e4f48_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputTextWrapper_vue__ = __webpack_require__("wpXN");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputTextWrapper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_268e4f48_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_b_carousel_slide_img_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputTextWrapper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper_Header__ = __webpack_require__("PaH+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_wrapper_Footer__ = __webpack_require__("EUrt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generales_modales_Cargando__ = __webpack_require__("mSax");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_wrapper_Section__ = __webpack_require__("vCYt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_generales_modales_Mensaje__ = __webpack_require__("58OK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_generales_FlechaArriba__ = __webpack_require__("a5iL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_js_EventBus__ = __webpack_require__("Zm3I");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  components: {
    Header: __WEBPACK_IMPORTED_MODULE_2__components_wrapper_Header__["a" /* default */],
    Footer: __WEBPACK_IMPORTED_MODULE_3__components_wrapper_Footer__["a" /* default */],
    Cargando: __WEBPACK_IMPORTED_MODULE_4__components_generales_modales_Cargando__["a" /* default */],
    Section: __WEBPACK_IMPORTED_MODULE_5__components_wrapper_Section__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_6__components_generales_modales_Mensaje__["a" /* default */],
    Flecha: __WEBPACK_IMPORTED_MODULE_7__components_generales_FlechaArriba__["a" /* default */]
  },
  data: function data() {
    return {
      modalCargando: false,
      modalError: false,
      modalAlerta: false,
      mensajeError: "",
      tituloError: "",
      botoneraDoble: false,
      recuperarContrasenia: false,
      ayudaMineduc: false,
      etapaProceso: null,
      destino: ""
    };
  },

  watch: {
    //Si cambiamos de pagina, cerramos el mensaje de carga
    $route: function $route() {
      this.modalCargando = false;
    }
  },
  created: function created() {
    var exist = this.$ss.ttl("jwt");
    if (exist > 0) {
      this.$ss.clear();
    }
  },

  beforeCreate: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_8__assets_js_EventBus__["a" /* EventBus */].$on("onError", function (mensaje) {
                _this.atraparError(mensaje);
              });

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeCreate() {
      return _ref.apply(this, arguments);
    }

    return beforeCreate;
  }(),
  methods: {
    handleScroll: function handleScroll() {
      window.scrollY > 0 ? (document.getElementById("myBtn").style.display = "block")(document.getElementById("flecha-abajo").style.display = "none") : document.getElementById("myBtn").style.display = "none";
      document.getElementById("flecha-abajo").style.display = "none";
    },
    //atrapa error y muestra modal con informacion correspondiente
    atraparError: function atraparError(mensaje, titulo, tipoBotonera, ayuda, codigo) {
      this.tituloError = titulo ? titulo : "Error";
      this.mensajeError = mensaje;
      if (codigo) {
        if (codigo == 700) {
          this.recuperarContrasenia = true;
          this.destino = "OlvidoContrasena";
        }
      }
      this.$refs.modalError.showModal();
    },
    atraparAlerta: function atraparAlerta(mensaje, titulo, tipoBotonera, ayuda, codigo) {
      this.botoneraDoble = false;
      this.ayudaMineduc = false;
      this.tituloError = titulo ? titulo : "Alerta";
      this.mensajeError = mensaje;
      if (tipoBotonera) {
        this.botoneraDoble = true;
      }
      if (ayuda) {
        this.ayudaMineduc = true;
      }
      if (codigo) {
        if (codigo == 503) {
          this.destino = "PostulacionFinalizada";
        }
      }
      this.$refs.modalAlerta.showModal();
    },

    //muestra modal cargando
    cargar: function cargar() {
      this.modalCargando = true;
    },

    //quita modal de cargando
    cargado: function cargado() {
      this.modalCargando = false;
    }
  }
});

/***/ }),

/***/ "xdtW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return manejoErrores; });
var manejoErrores = {
  data: function data() {
    return {
      errores: [],
      modificado: []
    };
  },


  methods: {
    guardarError: function guardarError(campo, mensaje) {
      this.errores.push({ campo: campo, mensaje: mensaje });
    },

    limpiarError: function limpiarError(campo) {
      var indice = this.errores.findIndex(function (e) {
        return e.campo == campo;
      });
      if (indice != -1) {
        this.errores.splice(indice, 1);
      }
    },

    mensajeError: function mensajeError(campo) {
      var error = this.errores.find(function (e) {
        return e.campo == campo;
      });
      return error ? error.mensaje : "";
    },

    tieneError: function tieneError(campo) {
      if (this.modificado.indexOf(campo) != -1) {
        return this.errores.find(function (e) {
          return e.campo == campo;
        }) ? false : null;
      }
      return null;
    }
  }
};

/***/ }),

/***/ "xzdP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["titulo", "subtitulo", "tamanioTitulo"],
  data: function data() {
    return {
      claseTituo: " gilmer text-azul mt-2 px-3 px-lg- font-weight-bold text-center"
    };
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.05d21b061cfff37e4075.js